<template>
  <div class="dataCollection">
    <div class="chargeOverview">
      <div class="chargeOverview-top">
        <h3>教育费用概览</h3>
      </div>
      <div class="chargeOverview-bottom">
        <div class="chargeOverview-bottom-left">
          <p v-if="createdChildrenStatus">客户当前有<span>{{chargeOverviewDataObj.childCount}}</span>位子女需要完成学业，在未来的学习生涯中，将会产生学费<span>{{chargeOverviewDataObj.schoolCostTotal| addMoneyFilter}}元</span>，生活费<span>{{chargeOverviewDataObj.lifeCostTotal| addMoneyFilter}}元</span>。</p>
          <p v-else>客户当前暂无子女需要完成学业 。</p>
          <v-chart :options="chargeOverviewData"
                   v-if="chargeOverviewDataShow && createdChildrenStatus"
                   style="    height: 250px"></v-chart>
        </div>
        <div class="chargeOverview-bottom-right">
          <div class="chargeOverview-bottom-right-title">
            <h4>教育储蓄金</h4>
            <el-popover placement="top"
                        v-if="savings.tipsStatus==='2'"
                        trigger="hover"
                        :content="savings.tipsComment">
              <img src="@/assets/images/wpsp/children-education/info-prompt.png"
                   slot="reference">
            </el-popover>
          </div>
          <div class="chargeOverview-bottom-right-main">
            <div>
              <p>客户当前已为子女准备了教育储备金</p>
              <el-input v-model="educationReserve.currentMoney"
                        placeholder=""
                        size="small"
                        @input.native="educationReserve.currentMoney=
                            educationReserve.currentMoney.replace
                            (educationReserve.currentMoney,RestrictedMoney
                            (educationReserve.currentMoney))"
                        @blur="educationReserveBlurFn(educationReserve.currentMoney, $event, 1)"
                        @focus="educationReserveFocusFn($event)">
              </el-input>
              元。
            </div>
            <div style="overflow:hidden;">
              <transition name="verificationText-style">
                <p class="verificationText"
                   style="padding-left: 50%;"
                   v-if="educationReserveText.currentMoney.currentMoneyStatus">{{educationReserveText.currentMoney.currentMoneyText}}</p>
              </transition>
            </div>
            <div>
              <p>计划未来每月储蓄</p>
              <el-input v-model="educationReserve.monthMoney"
                        placeholder=""
                        size="small"
                        @input.native="educationReserve.monthMoney=
                            educationReserve.monthMoney.replace
                            (educationReserve.monthMoney,RestrictedMoney
                            (educationReserve.monthMoney))"
                        @blur="educationReserveBlurFn(educationReserve.monthMoney, $event, 2)"
                        @focus="educationReserveFocusFn($event)" />
              元。
            </div>
            <div style="overflow:hidden;">
              <transition name="verificationText-style">
                <p class="verificationText"
                   style="padding-left: 27%;"
                   v-if="educationReserveText.monthMoney.monthMoneyStatus">{{educationReserveText.monthMoney.monthMoneyText}}</p>
              </transition>
            </div>
            <div>
              <p>期望教育储备金每年能产生</p>
              <el-input v-model="educationReserve.expectedRevenue"
                        placeholder=""
                        size="small"
                        @input.native="educationReserve.expectedRevenue=
                            educationReserve.expectedRevenue.replace
                            (educationReserve.expectedRevenue,RestrictedMoney2
                            (educationReserve.expectedRevenue))"
                        @blur="educationReserveBlurFn(educationReserve.expectedRevenue, $event, 3)"
                        @focus="educationReserveFocusFn($event)" />
              %的收益率。
            </div>
            <div style="overflow:hidden;">
              <transition name="verificationText-style">
                <p class="verificationText"
                   style="padding-left: 40%;"
                   v-if="educationReserveText.expectedRevenue.expectedRevenueStatus">{{educationReserveText.expectedRevenue.expectedRevenueText}}</p>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="chargeSetting">
      <div class="chargeSetting-top">
        <h4>教育费用配置</h4>
        <el-popover placement="top"
                    v-if="educationExpenses.tipsStatus==='2'"
                    trigger="hover"
                    :content="educationExpenses.tipsComment">
          <img src="@/assets/images/wpsp/children-education/info-prompt.png"
               slot="reference">
        </el-popover>
      </div>
      <div class="chargeSetting-bottom">
        <div class="chargeSetting-bottom-left">
          <el-tabs v-if="createdChildrenStatus"
                   v-model="editableTabsValue"
                   tab-position="left"
                   @tab-click="tabsClick(editableTabsValue)"
                   closable
                   @tab-remove="removeTab">
            <!--                <el-tab-pane-->
            <!--                  v-for="(item, index) in editableTabs"-->
            <!--                  :key="index"-->
            <!--                  :label="item.custName"-->
            <!--                  :name="index.toString()"-->
            <!--                >-->
            <el-tab-pane v-for="(item, index) in editableTabs"
                         :key="index"
                         :label="item.custName"
                         :name="index.toString()">
              <span slot="label">
                <el-tooltip class="item"
                            effect="light"
                            :content="item.custName"
                            placement="bottom">
                  <span>{{item.custName | wpspChildNmaeFilter}}</span>
                </el-tooltip>
              </span>
              <div style="padding: 20px 0 30px 20px;">
                <span>当前处于</span>
                <el-select v-model="item.currentClass"
                           placeholder="请选择"
                           @change="selectChange(item.currentClass, index, item.enterSchoolYear)">
                  <el-option v-for="i in item.eduLeveUsed"
                             :key="i.dictValue"
                             :label="i.dictName"
                             :value="i.dictValue"></el-option>
                </el-select>
                <span v-if="selectValue < 1">预计</span>
                <div style="display: inline-block;position: relative;">
                  <input v-if="selectValue < 1"
                         class="keep_input"
                         v-number-only
                         style="width:50px;margin: 0 10px;"
                         v-model="item.enterSchoolYear"
                         @blur="selectBlur(item.currentClass, index, item.enterSchoolYear, $event)" />
                  <transition name="verificationText-style">
                    <p style="position: absolute;bottom: -80%;left: -50%;display: block;width: 150px;text-align: center;"
                       class="verificationText"
                       v-if="enterSchoolYearCode">{{enterSchoolYearText}}</p>
                  </transition>
                </div>
                <span v-if="selectValue < 1">年后入学</span>
              </div>
              <p style="padding-left: 20px;">此间将产生学费{{item.childCostInfoList[0].moneyTotal|addMoneyFilter}}元，生活费{{item.childCostInfoList[1].moneyTotal|addMoneyFilter}}元。</p>
            </el-tab-pane>
          </el-tabs>
          <el-button type="text"
                     :disabled="editableTabs.length >= 10"
                     class="addChildStyle"
                     @click="addChildStatus = true"
                     v-if="createdChildrenStatus===true">+新增子女</el-button>
          <div class="analysisTabs-second-false"
               v-if="createdChildrenStatus!==true">
            <img src="@/assets/images/wpsp/children-education/analysisTabs-second-false.png"
                 alt="" />
            <div>
              <p>请添加子女信息。</p>
              <el-button type="primary"
                         @click="addChildStatus = true">+新增子女</el-button>
            </div>
          </div>
          <v-chart v-if="selectValue < 20 && chargeOverviewData2Show && createdChildrenStatus"
                   style="position: absolute;bottom: 0;left: 20%;"
                   :options="chargeOverviewData2"></v-chart>
        </div>
        <div class="chargeSetting-bottom-right">
          <div class="chargeSetting-bottom-right-title">
            <ul>
              <li>
                <p>阶段</p>
                <el-popover placement="top"
                            v-if="stage.tipsStatus==='2'"
                            trigger="hover"
                            :content="stage.tipsComment">
                  <img src="@/assets/images/wpsp/children-education/info-prompt.png"
                       slot="reference" style="width:14px;">
                </el-popover>
              </li>
              <li>
                <p>年级</p>
                <el-popover placement="top"
                            v-if="grade.tipsStatus==='2'"
                            trigger="hover"
                            :content="grade.tipsComment">
                  <img src="@/assets/images/wpsp/children-education/info-prompt.png"
                       slot="reference" style="width:14px;">
                </el-popover>
              </li>
              <li>
                <p>学费</p>
                <el-popover placement="top"
                            v-if="tuition.tipsStatus==='2'"
                            trigger="hover"
                            :content="tuition.tipsComment">
                  <img src="@/assets/images/wpsp/children-education/info-prompt.png"
                       slot="reference" style="width:14px;">
                </el-popover>
              </li>
              <li>
                <p>生活费</p>
                <el-popover placement="top"
                            v-if="livingExpenses.tipsStatus==='2'"
                            trigger="hover"
                            :content="livingExpenses.tipsComment">
                  <img src="@/assets/images/wpsp/children-education/info-prompt.png"
                       slot="reference" style="width:14px;">
                </el-popover>
              </li>
            </ul>
          </div>
          <el-collapse accordion
                       v-if="createdChildrenStatus">
            <el-collapse-item v-if="selectValue < 4">
              <template slot="title">
                <div class="flex-div">
                  <span>幼儿园</span>
                  <div>
                    <el-input v-model="children.listFirst.kindergartemSchool"
                              placeholder="幼儿园学费"
                              @input.native="children.listFirst.kindergartemSchool=
                                  children.listFirst.kindergartemSchool.replace
                                  (children.listFirst.kindergartemSchool,RestrictedMoney3
                                  (children.listFirst.kindergartemSchool, $event))"
                              @blur="outBlurFn('kindergartemSchool',
                                  children.listFirst.kindergartemSchool, $event)"
                              @change="materielExtraCostChange(children.listFirst.kindergartemSchool)"
                              @focus="ObtainFocus($event)"></el-input>
                    <el-input v-model="children.listFirst.kindergartemLife"
                              @input.native="children.listFirst.kindergartemLife=
                                  children.listFirst.kindergartemLife.replace
                                  (children.listFirst.kindergartemLife,RestrictedMoney3
                                  (children.listFirst.kindergartemLife, $event))"
                              @blur="outBlurFn('kindergartemLife',
                                  children.listFirst.kindergartemLife, $event)"
                              @change="materielExtraCostChange2(children.listFirst.kindergartemLife)"
                              @focus="ObtainFocus($event)"
                              placeholder="幼儿园生活费"></el-input>
                  </div>
                </div>
              </template>
              <div v-if="selectValue < 2"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>幼儿园小班</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class1"
                            @input.native="children.listSecond[0].class1=
                                 children.listSecond[0].class1.replace
                                  (children.listSecond[0].class1,RestrictedMoney3
                                  (children.listSecond[0].class1, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class1)"
                            @blur="innerBlurFn('class1', children.listSecond[0].class1, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="幼儿园小班学费"></el-input>
                  <el-input v-model="children.listSecond[1].class1"
                            @blur="innerBlurFn('class1',
                               children.listSecond[1].class1, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="幼儿园小班生活费"></el-input>
                </div>
              </div>
              <div v-if="selectValue < 3"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>幼儿园中班</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class2"
                            @input.native="children.listSecond[0].class2=
                              children.listSecond[0].class2.replace
                              (children.listSecond[0].class2,RestrictedMoney3
                              (children.listSecond[0].class2, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class2)"
                            @blur="innerBlurFn('class2',
                              children.listSecond[0].class2, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="幼儿园中班学费"></el-input>
                  <el-input v-model="children.listSecond[1].class2"
                            @input.native="children.listSecond[1].class2=
                              children.listSecond[1].class2.replace
                              (children.listSecond[1].class2,RestrictedMoney3
                              (children.listSecond[1].class2, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class2)"
                            @blur="innerBlurFn('class2',
                              children.listSecond[1].class2, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="幼儿园中班生活费"></el-input>
                </div>
              </div>
              <div v-if="selectValue < 4"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>幼儿园大班</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class3"
                            @input.native="children.listSecond[0].class3=
                                children.listSecond[0].class3.replace
                                (children.listSecond[0].class3,RestrictedMoney3
                                (children.listSecond[0].class3, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class3)"
                            @blur="innerBlurFn('class3', children.listSecond[0].class3, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="幼儿园大班学费"></el-input>
                  <el-input v-model="children.listSecond[1].class3"
                            @blur="innerBlurFn('class3', children.listSecond[1].class3, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="幼儿园大班生活费"></el-input>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item v-if="selectValue < 10">
              <template slot="title">
                <div class="flex-div">
                  <span>小学</span>
                  <div>
                    <el-input v-model="children.listFirst.primarySchool"
                              @input.native="children.listFirst.primarySchool=
                                  children.listFirst.primarySchool.replace
                                  (children.listFirst.primarySchool,RestrictedMoney3
                                  (children.listFirst.primarySchool, $event))"
                              @change="materielExtraCostChange(children.listFirst.primarySchool)"
                              @blur="outBlurFn('primarySchool', children.listFirst.primarySchool, $event)"
                              @focus="ObtainFocus($event)"
                              placeholder="小学学费"></el-input>
                    <el-input v-model="children.listFirst.primaryLife"
                              @input.native="children.listFirst.primaryLife=
                                  children.listFirst.primaryLife.replace
                                  (children.listFirst.primaryLife,RestrictedMoney3
                                  (children.listFirst.primaryLife, $event))"
                              @change="materielExtraCostChange(children.listFirst.primaryLife)"
                              @blur="outBlurFn('primaryLife', children.listFirst.primaryLife, $event)"
                              @focus="ObtainFocus($event)"
                              placeholder="小学生活费"></el-input>
                  </div>
                </div>
              </template>
              <div v-if="selectValue < 5"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"> <span>一年级</span> </div>
                <div>
                  <el-input v-model="children.listSecond[0].class4"
                            @input.native="children.listSecond[0].class4=
                                  children.listSecond[0].class4.replace
                                  (children.listSecond[0].class4,RestrictedMoney3
                                  (children.listSecond[0].class4, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class4)"
                            @blur="innerBlurFn('class4', children.listSecond[0].class4, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="小学一年级学费"></el-input>
                  <el-input v-model="children.listSecond[1].class4"
                            @input.native="children.listSecond[1].class4=
                                  children.listSecond[1].class4.replace
                                  (children.listSecond[1].class4,RestrictedMoney3
                                  (children.listSecond[1].class4, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class4)"
                            @blur="innerBlurFn('class4', children.listSecond[1].class4, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="小学一年级生活费"></el-input>
                </div>
              </div>
              <div v-if="selectValue < 6"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>二年级</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class5"
                            @input.native="children.listSecond[0].class5=
                                  children.listSecond[0].class5.replace
                                  (children.listSecond[0].class5,RestrictedMoney3
                                  (children.listSecond[0].class5, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class5)"
                            @blur="innerBlurFn('class5', children.listSecond[0].class5, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="小学二年级学费"></el-input>
                  <el-input v-model="children.listSecond[1].class5"
                            @input.native="children.listSecond[1].class5=
                                  children.listSecond[1].class5.replace
                                  (children.listSecond[1].class5,RestrictedMoney3
                                  (children.listSecond[1].class5, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class5)"
                            @blur="innerBlurFn('class5', children.listSecond[1].class5, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="小学二年级生活费"></el-input>
                </div>
              </div>
              <div v-if="selectValue < 7"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>三年级</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class6"
                            @input.native="children.listSecond[0].class6=
                                  children.listSecond[0].class6.replace
                                  (children.listSecond[0].class6,RestrictedMoney3
                                  (children.listSecond[0].class6, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class6)"
                            @blur="innerBlurFn('class6', children.listSecond[0].class6, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="小学三年级学费"></el-input>
                  <el-input v-model="children.listSecond[1].class6"
                            @input.native="children.listSecond[1].class6=
                                  children.listSecond[1].class6.replace
                                  (children.listSecond[1].class6,RestrictedMoney3
                                  (children.listSecond[1].class6, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class6)"
                            @blur="innerBlurFn('class6', children.listSecond[1].class6, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="小学三年级生活费"></el-input>
                </div>
              </div>
              <div v-if="selectValue < 8"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>四年级</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class7"
                            @input.native="children.listSecond[0].class7=
                                  children.listSecond[0].class7.replace
                                  (children.listSecond[0].class7,RestrictedMoney3
                                  (children.listSecond[0].class7, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class7)"
                            @blur="innerBlurFn('class7', children.listSecond[0].class7, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="小学四年级学费"></el-input>
                  <el-input v-model="children.listSecond[1].class7"
                            @input.native="children.listSecond[1].class7=
                                  children.listSecond[1].class7.replace
                                  (children.listSecond[1].class7,RestrictedMoney3
                                  (children.listSecond[1].class7, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class7)"
                            @blur="innerBlurFn('class7', children.listSecond[1].class7, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="小学四年级生活费"></el-input>
                </div>
              </div>
              <div v-if="selectValue < 9"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>五年级</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class8"
                            @input.native="children.listSecond[0].class8=
                                  children.listSecond[0].class8.replace
                                  (children.listSecond[0].class8,RestrictedMoney3
                                  (children.listSecond[0].class8, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class8)"
                            @blur="innerBlurFn('class8', children.listSecond[0].class8, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="小学五年级学费"></el-input>
                  <el-input v-model="children.listSecond[1].class8"
                            @input.native="children.listSecond[1].class8=
                                  children.listSecond[1].class8.replace
                                  (children.listSecond[1].class8,RestrictedMoney3
                                  (children.listSecond[1].class8, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class8)"
                            @blur="innerBlurFn('class8', children.listSecond[1].class8, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="小学五年级生活费"></el-input>
                </div>
              </div>
              <div v-if="selectValue < 10"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>六年级</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class9"
                            @input.native="children.listSecond[0].class9=
                                children.listSecond[0].class9.replace
                                (children.listSecond[0].class9,RestrictedMoney3
                                (children.listSecond[0].class9, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class9)"
                            @blur="innerBlurFn('class9', children.listSecond[0].class9, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="小学六年级学费"></el-input>
                  <el-input v-model="children.listSecond[1].class9"
                            @input.native="children.listSecond[1].class9=
                                children.listSecond[1].class9.replace
                                (children.listSecond[1].class9,RestrictedMoney3
                                (children.listSecond[1].class9, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class9)"
                            @blur="innerBlurFn('class9', children.listSecond[1].class9, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="小学六年级生活费"></el-input>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item v-if="selectValue < 13">
              <template slot="title">
                <div class="flex-div">
                  <span>初中</span>
                  <div>
                    <el-input v-model="children.listFirst.juniorHighSchool"
                              @input.native="children.listFirst.juniorHighSchool=
                                  children.listFirst.juniorHighSchool.replace
                                  (children.listFirst.juniorHighSchool,RestrictedMoney3
                                  (children.listFirst.juniorHighSchool, $event))"
                              @change="materielExtraCostChange(children.listFirst.juniorHighSchool)"
                              @blur="outBlurFn('juniorHighSchool', children.listFirst.juniorHighSchool, $event)"
                              @focus="ObtainFocus($event)"
                              placeholder="初中学费"></el-input>
                    <el-input v-model="children.listFirst.juniorHighLife"
                              @input.native="children.listFirst.juniorHighLife=
                                  children.listFirst.juniorHighLife.replace
                                  (children.listFirst.juniorHighLife,RestrictedMoney3
                                  (children.listFirst.juniorHighLife, $event))"
                              @change="materielExtraCostChange(children.listFirst.juniorHighLife)"
                              @blur="outBlurFn('juniorHighLife', children.listFirst.juniorHighLife, $event)"
                              @focus="ObtainFocus($event)"
                              placeholder="初中生活费"></el-input>
                  </div>
                </div>
              </template>
              <div v-if="selectValue < 11"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"> <span>初一</span> </div>
                <div>
                  <el-input v-model="children.listSecond[0].class10"
                            @input.native="children.listSecond[0].class10=
                                children.listSecond[0].class10.replace
                                (children.listSecond[0].class10,RestrictedMoney3
                                (children.listSecond[0].class10, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class10)"
                            @blur="innerBlurFn('class10', children.listSecond[0].class10, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="初一学费"></el-input>
                  <el-input v-model="children.listSecond[1].class10"
                            @input.native="children.listSecond[1].class10=
                                children.listSecond[1].class10.replace
                                (children.listSecond[1].class10,RestrictedMoney3
                                (children.listSecond[1].class10, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class10)"
                            @blur="innerBlurFn('class10', children.listSecond[1].class10, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="初一生活费"></el-input>
                </div>
              </div>
              <div v-if="selectValue < 12"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>初二</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class11"
                            @input.native="children.listSecond[0].class11=
                              children.listSecond[0].class11.replace
                              (children.listSecond[0].class11,RestrictedMoney3
                              (children.listSecond[0].class11, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class11)"
                            @blur="innerBlurFn('class11', children.listSecond[0].class11, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="初二学费"></el-input>
                  <el-input v-model="children.listSecond[1].class11"
                            @input.native="children.listSecond[1].class11=
                              children.listSecond[1].class11.replace
                              (children.listSecond[1].class11,RestrictedMoney3
                              (children.listSecond[1].class11, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class11)"
                            @blur="innerBlurFn('class11', children.listSecond[1].class11, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="初二生活费"></el-input>
                </div>
              </div>
              <div v-if="selectValue < 13"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>初三</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class12"
                            @input.native="children.listSecond[0].class12=
                              children.listSecond[0].class12.replace
                              (children.listSecond[0].class12,RestrictedMoney3
                              (children.listSecond[0].class12, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class12)"
                            @blur="innerBlurFn('class12', children.listSecond[0].class12, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="初三学费"></el-input>
                  <el-input v-model="children.listSecond[1].class12"
                            @input.native="children.listSecond[1].class12=
                              children.listSecond[1].class12.replace
                              (children.listSecond[1].class12,RestrictedMoney3
                              (children.listSecond[1].class12, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class12)"
                            @blur="innerBlurFn('class12', children.listSecond[1].class12, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="初三生活费"></el-input>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item v-if="selectValue < 16">
              <template slot="title">
                <div class="flex-div">
                  <span>高中</span>
                  <div>
                    <el-input v-model="children.listFirst.seniorHighSchool"
                              @input.native="children.listFirst.seniorHighSchool=
                                children.listFirst.seniorHighSchool.replace
                                (children.listFirst.seniorHighSchool,RestrictedMoney3
                                (children.listFirst.seniorHighSchool, $event))"
                              @change="materielExtraCostChange(children.listFirst.seniorHighSchool)"
                              @blur="outBlurFn('seniorHighSchool', children.listFirst.seniorHighSchool, $event)"
                              @focus="ObtainFocus($event)"
                              placeholder="高中学费"></el-input>
                    <el-input v-model="children.listFirst.seniorHighLife"
                              @input.native="children.listFirst.seniorHighLife=
                                children.listFirst.seniorHighLife.replace
                                (children.listFirst.seniorHighLife,RestrictedMoney3
                                (children.listFirst.seniorHighLife, $event))"
                              @change="materielExtraCostChange(children.listFirst.seniorHighLife)"
                              @blur="outBlurFn('seniorHighLife', children.listFirst.seniorHighLife, $event)"
                              @focus="ObtainFocus($event)"
                              placeholder="高中生活费"></el-input>
                  </div>
                </div>
              </template>
              <div v-if="selectValue < 14"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"> <span>高一</span> </div>
                <div>
                  <el-input v-model="children.listSecond[0].class13"
                            @input.native="children.listSecond[0].class13=
                                children.listSecond[0].class13.replace
                                (children.listSecond[0].class13,RestrictedMoney3
                                (children.listSecond[0].class13, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class13)"
                            @blur="innerBlurFn('class13', children.listSecond[0].class13, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="高一学费"></el-input>
                  <el-input v-model="children.listSecond[1].class13"
                            @input.native="children.listSecond[1].class13=
                                children.listSecond[1].class13.replace
                                (children.listSecond[1].class13,RestrictedMoney3
                                (children.listSecond[1].class13, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class13)"
                            @blur="innerBlurFn('class13', children.listSecond[1].class13, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="高一生活费"></el-input>
                </div>
              </div>
              <div v-if="selectValue < 15"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>高二</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class14"
                            @input.native="children.listSecond[0].class14=
                                children.listSecond[0].class14.replace
                                (children.listSecond[0].class14,RestrictedMoney3
                                (children.listSecond[0].class14, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class14)"
                            @blur="innerBlurFn('class14', children.listSecond[0].class14, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="高二学费"></el-input>
                  <el-input v-model="children.listSecond[1].class14"
                            @input.native="children.listSecond[1].class14=
                                children.listSecond[1].class14.replace
                                (children.listSecond[1].class14,RestrictedMoney3
                                (children.listSecond[1].class14, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class14)"
                            @blur="innerBlurFn('class14', children.listSecond[1].class14, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="高二生活费"></el-input>
                </div>
              </div>
              <div v-if="selectValue < 16"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>高三</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class15"
                            @input.native="children.listSecond[0].class15=
                              children.listSecond[0].class15.replace
                              (children.listSecond[0].class15,RestrictedMoney3
                              (children.listSecond[0].class15, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class15)"
                            @blur="innerBlurFn('class15', children.listSecond[0].class15, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="高三学费"></el-input>
                  <el-input v-model="children.listSecond[1].class15"
                            @input.native="children.listSecond[1].class15=
                              children.listSecond[1].class15.replace
                              (children.listSecond[1].class15,RestrictedMoney3
                              (children.listSecond[1].class15, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class15)"
                            @blur="innerBlurFn('class15', children.listSecond[1].class15, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="高三生活费"></el-input>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item v-if="selectValue < 20">
              <template slot="title">
                <div class="flex-div">
                  <span>大学</span>
                  <div>
                    <el-input v-model="children.listFirst.universitySchool"
                              @input.native="children.listFirst.universitySchool=
                                  children.listFirst.universitySchool.replace
                                  (children.listFirst.universitySchool,RestrictedMoney3
                                  (children.listFirst.universitySchool, $event))"
                              @change="materielExtraCostChange(children.listFirst.universitySchool)"
                              @blur="outBlurFn('universitySchool', children.listFirst.universitySchool, $event)"
                              @focus="ObtainFocus($event)"
                              placeholder="大学学费"></el-input>
                    <el-input v-model="children.listFirst.universityLife"
                              @input.native="children.listFirst.universityLife=
                                  children.listFirst.universityLife.replace
                                  (children.listFirst.universityLife,RestrictedMoney3
                                  (children.listFirst.universityLife, $event))"
                              @change="materielExtraCostChange(children.listFirst.universityLife)"
                              @blur="outBlurFn('universityLife', children.listFirst.universityLife, $event)"
                              @focus="ObtainFocus($event)"
                              placeholder="大学活费"></el-input>
                  </div>
                </div>
              </template>
              <div v-if="selectValue < 17"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"> <span>大一</span> </div>
                <div>
                  <el-input v-model="children.listSecond[0].class16"
                            @input.native="children.listSecond[0].class16=
                                  children.listSecond[0].class16.replace
                                  (children.listSecond[0].class16,RestrictedMoney3
                                  (children.listSecond[0].class16, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class16)"
                            @blur="innerBlurFn('class16', children.listSecond[0].class16, 1, $event)"
                            @focus="ObtainFocus('class16',children.listSecond[0].class16,0,2)"
                            placeholder="大一学费"></el-input>
                  <el-input v-model="children.listSecond[1].class16"
                            @input.native="children.listSecond[1].class16=
                                  children.listSecond[1].class16.replace
                                  (children.listSecond[1].class16,RestrictedMoney3
                                  (children.listSecond[1].class16, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class16)"
                            @blur="innerBlurFn('class16', children.listSecond[1].class16, 2, $event)"
                            @focus="ObtainFocus('class16',children.listSecond[1].class16,1,2)"
                            placeholder="大一生活费"></el-input>
                </div>
              </div>
              <div v-if="selectValue < 18"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>大二</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class17"
                            @input.native="children.listSecond[0].class17=
                                  children.listSecond[0].class17.replace
                                  (children.listSecond[0].class17,RestrictedMoney3
                                  (children.listSecond[0].class17, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class17)"
                            @blur="innerBlurFn('class17', children.listSecond[0].class17, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="大二学费"></el-input>
                  <el-input v-model="children.listSecond[1].class17"
                            @input.native="children.listSecond[1].class17=
                                  children.listSecond[1].class17.replace
                                  (children.listSecond[1].class17,RestrictedMoney3
                                  (children.listSecond[1].class17, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class17)"
                            @blur="innerBlurFn('class17', children.listSecond[1].class17, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="大二生活费"></el-input>
                </div>
              </div>
              <div v-if="selectValue < 19"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>大三</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class18"
                            @input.native="children.listSecond[0].class18=
                                  children.listSecond[0].class18.replace
                                  (children.listSecond[0].class18,RestrictedMoney3
                                  (children.listSecond[0].class18, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class18)"
                            @blur="innerBlurFn('class18', children.listSecond[0].class18, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="大三学费"></el-input>
                  <el-input v-model="children.listSecond[1].class18"
                            @input.native="children.listSecond[1].class18=
                                  children.listSecond[1].class18.replace
                                  (children.listSecond[1].class18,RestrictedMoney3
                                  (children.listSecond[1].class18, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class18)"
                            @blur="innerBlurFn('class18', children.listSecond[1].class18, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="大三生活费"></el-input>
                </div>
              </div>
              <div v-if="selectValue < 20"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>大四</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class19"
                            @input.native="children.listSecond[0].class19=
                                children.listSecond[0].class19.replace
                                (children.listSecond[0].class19,RestrictedMoney3
                                (children.listSecond[0].class19, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class19)"
                            @blur="innerBlurFn('class19', children.listSecond[0].class19, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="大四学费"></el-input>
                  <el-input v-model="children.listSecond[1].class19"
                            @input.native="children.listSecond[1].class19=
                                children.listSecond[1].class19.replace
                                (children.listSecond[1].class19,RestrictedMoney3
                                (children.listSecond[1].class19, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class19)"
                            @blur="innerBlurFn('class19', children.listSecond[1].class19, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="大四生活费"></el-input>
                </div>
              </div>
            </el-collapse-item>
            <!--            *** 下面是硕士-->
            <el-collapse-item v-if="selectValue < 23">
              <template slot="title">
                <div class="flex-div">
                  <!--                  <span>硕士</span>-->
                  <div class="checkbox-div">
                    <el-checkbox v-model="childrenCheckedMa"></el-checkbox>
                    <el-select v-model="childrenSelectMaData"
                               placeholder="请选择">
                      <el-option v-for="item in childrenSelectMaList"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div>
                    <el-input v-model="children.listFirst.maSchool"
                              :disabled="!childrenCheckedMa"
                              @input.native="children.listFirst.maSchool=
                                  children.listFirst.maSchool.replace
                                  (children.listFirst.maSchool,RestrictedMoney3
                                  (children.listFirst.maSchool, $event))"
                              @change="materielExtraCostChange(children.listFirst.maSchool)"
                              @blur="outBlurFn('maSchool', children.listFirst.maSchool, $event)"
                              @focus="ObtainFocus($event)"
                              placeholder="硕士生学费"></el-input>
                    <el-input v-model="children.listFirst.maLife"
                              :disabled="!childrenCheckedMa"
                              @input.native="children.listFirst.maLife=
                                  children.listFirst.maLife.replace
                                  (children.listFirst.maLife,RestrictedMoney3
                                  (children.listFirst.maLife, $event))"
                              @change="materielExtraCostChange(children.listFirst.maLife)"
                              @blur="outBlurFn('maLife', children.listFirst.maLife, $event)"
                              @focus="ObtainFocus($event)"
                              placeholder="硕士生活费"></el-input>
                  </div>
                </div>
              </template>
              <div v-if="selectValue < 21"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"> <span>硕士一年级</span> </div>
                <div>
                  <el-input v-model="children.listSecond[0].class20"
                            :disabled="!childrenCheckedMa"
                            @input.native="children.listSecond[0].class20=
                                  children.listSecond[0].class20.replace
                                  (children.listSecond[0].class20,RestrictedMoney3
                                  (children.listSecond[0].class20, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class20)"
                            @blur="innerBlurFn('class20', children.listSecond[0].class20, 1, $event)"
                            @focus="ObtainFocus('class20',children.listSecond[0].class20,0,2)"
                            placeholder="硕士一年级学费"></el-input>
                  <el-input v-model="children.listSecond[1].class20"
                            :disabled="!childrenCheckedMa"
                            @input.native="children.listSecond[1].class20=
                                  children.listSecond[1].class20.replace
                                  (children.listSecond[1].class20,RestrictedMoney3
                                  (children.listSecond[1].class20, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class20)"
                            @blur="innerBlurFn('class20', children.listSecond[1].class20, 2, $event)"
                            @focus="ObtainFocus('class20',children.listSecond[1].class20,1,2)"
                            placeholder="硕士一年级生活费"></el-input>
                </div>
              </div>
              <div v-if="selectValue < 22"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>硕士二年级</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class21"
                            :disabled="!childrenCheckedMa"
                            @input.native="children.listSecond[0].class21=
                                  children.listSecond[0].class21.replace
                                  (children.listSecond[0].class21,RestrictedMoney3
                                  (children.listSecond[0].class21, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class21)"
                            @blur="innerBlurFn('class21', children.listSecond[0].class21, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="硕士二年级学费"></el-input>
                  <el-input v-model="children.listSecond[1].class21"
                            :disabled="!childrenCheckedMa"
                            @input.native="children.listSecond[1].class21=
                                  children.listSecond[1].class21.replace
                                  (children.listSecond[1].class21,RestrictedMoney3
                                  (children.listSecond[1].class21, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class21)"
                            @blur="innerBlurFn('class21', children.listSecond[1].class21, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="硕士二年级生活费"></el-input>
                </div>
              </div>
              <div v-if="selectValue < 23 && childrenSelectMaData === '2'"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>硕士三年级</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class22"
                            :disabled="!childrenCheckedMa"
                            @input.native="children.listSecond[0].class22=
                                  children.listSecond[0].class22.replace
                                  (children.listSecond[0].class22,RestrictedMoney3
                                  (children.listSecond[0].class22, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class22)"
                            @blur="innerBlurFn('class22', children.listSecond[0].class22, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="硕士三年级学费"></el-input>
                  <el-input v-model="children.listSecond[1].class22"
                            :disabled="!childrenCheckedMa"
                            @input.native="children.listSecond[1].class22=
                                  children.listSecond[1].class22.replace
                                  (children.listSecond[1].class22,RestrictedMoney3
                                  (children.listSecond[1].class22, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class22)"
                            @blur="innerBlurFn('class22', children.listSecond[1].class22, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="硕士三年级生活费"></el-input>
                </div>
              </div>
            </el-collapse-item>
            <!--            *** 下面是博士-->
            <el-collapse-item v-if="selectValue < 27">
              <template slot="title">
                <div class="flex-div">
                  <!--                  <span>博士</span>-->
                  <div class="checkbox-div">
                    <el-checkbox v-model="childrenCheckedDr"></el-checkbox>
                    <el-select v-model="childrenSelectDrData"
                               placeholder="请选择">
                      <el-option v-for="item in childrenSelectDrList"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div>
                    <el-input v-model="children.listFirst.drSchool"
                              :disabled="!childrenCheckedDr"
                              @input.native="children.listFirst.drSchool=
                                  children.listFirst.drSchool.replace
                                  (children.listFirst.drSchool,RestrictedMoney3
                                  (children.listFirst.drSchool, $event))"
                              @change="materielExtraCostChange(children.listFirst.drSchool)"
                              @blur="outBlurFn('drSchool', children.listFirst.drSchool, $event)"
                              @focus="ObtainFocus($event)"
                              placeholder="博士生学费"></el-input>
                    <el-input v-model="children.listFirst.drLife"
                              :disabled="!childrenCheckedDr"
                              @input.native="children.listFirst.drLife=
                                  children.listFirst.drLife.replace
                                  (children.listFirst.drLife,RestrictedMoney3
                                  (children.listFirst.drLife, $event))"
                              @change="materielExtraCostChange(children.listFirst.drLife)"
                              @blur="outBlurFn('drLife', children.listFirst.drLife, $event)"
                              @focus="ObtainFocus($event)"
                              placeholder="博士生活费"></el-input>
                  </div>
                </div>
              </template>
              <div v-if="selectValue < 24"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"> <span>博士一年级</span> </div>
                <div>
                  <el-input v-model="children.listSecond[0].class23"
                            :disabled="!childrenCheckedDr"
                            @input.native="children.listSecond[0].class23=
                                  children.listSecond[0].class23.replace
                                  (children.listSecond[0].class23,RestrictedMoney3
                                  (children.listSecond[0].class23, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class23)"
                            @blur="innerBlurFn('class23', children.listSecond[0].class23, 1, $event)"
                            @focus="ObtainFocus('class23',children.listSecond[0].class23,0,2)"
                            placeholder="博士一年级学费"></el-input>
                  <el-input v-model="children.listSecond[1].class23"
                            :disabled="!childrenCheckedDr"
                            @input.native="children.listSecond[1].class23=
                                  children.listSecond[1].class23.replace
                                  (children.listSecond[1].class23,RestrictedMoney3
                                  (children.listSecond[1].class23, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class23)"
                            @blur="innerBlurFn('class23', children.listSecond[1].class23, 2, $event)"
                            @focus="ObtainFocus('class23',children.listSecond[1].class23,1,2)"
                            placeholder="博士一年级生活费"></el-input>
                </div>
              </div>
              <div v-if="selectValue < 25"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>博士二年级</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class24"
                            :disabled="!childrenCheckedDr"
                            @input.native="children.listSecond[0].class24=
                                  children.listSecond[0].class24.replace
                                  (children.listSecond[0].class24,RestrictedMoney3
                                  (children.listSecond[0].class24, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class24)"
                            @blur="innerBlurFn('class24', children.listSecond[0].class24, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="博士二年级学费"></el-input>
                  <el-input v-model="children.listSecond[1].class24"
                            :disabled="!childrenCheckedDr"
                            @input.native="children.listSecond[1].class24=
                                  children.listSecond[1].class24.replace
                                  (children.listSecond[1].class24,RestrictedMoney3
                                  (children.listSecond[1].class24, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class24)"
                            @blur="innerBlurFn('class24', children.listSecond[1].class24, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="博士二年级生活费"></el-input>
                </div>
              </div>
              <div v-if="selectValue < 26"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>博士三年级</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class25"
                            :disabled="!childrenCheckedDr"
                            @input.native="children.listSecond[0].class25=
                                  children.listSecond[0].class25.replace
                                  (children.listSecond[0].class25,RestrictedMoney3
                                  (children.listSecond[0].class25, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class25)"
                            @blur="innerBlurFn('class25', children.listSecond[0].class25, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="博士三年级学费"></el-input>
                  <el-input v-model="children.listSecond[1].class25"
                            :disabled="!childrenCheckedDr"
                            @input.native="children.listSecond[1].class25=
                                  children.listSecond[1].class25.replace
                                  (children.listSecond[1].class25,RestrictedMoney3
                                  (children.listSecond[1].class25, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class25)"
                            @blur="innerBlurFn('class25', children.listSecond[1].class25, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="博士三年级生活费"></el-input>
                </div>
              </div>
              <div v-if="selectValue < 27 && childrenSelectDrData === '2'"
                   class="flex-div-inner">
                <div class="flex-div-inner-left"><span>博士四年级</span></div>
                <div>
                  <el-input v-model="children.listSecond[0].class26"
                            :disabled="!childrenCheckedDr"
                            @input.native="children.listSecond[0].class26=
                                  children.listSecond[0].class26.replace
                                  (children.listSecond[0].class26,RestrictedMoney3
                                  (children.listSecond[0].class26, $event))"
                            @change="materielExtraCostChange(children.listSecond[0].class26)"
                            @blur="innerBlurFn('class26', children.listSecond[0].class26, 1, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="博士四年级学费"></el-input>
                  <el-input v-model="children.listSecond[1].class26"
                            :disabled="!childrenCheckedDr"
                            @input.native="children.listSecond[1].class26=
                                  children.listSecond[1].class26.replace
                                  (children.listSecond[1].class26,RestrictedMoney3
                                  (children.listSecond[1].class26, $event))"
                            @change="materielExtraCostChange(children.listSecond[1].class26)"
                            @blur="innerBlurFn('class26', children.listSecond[1].class26, 2, $event)"
                            @focus="ObtainFocus($event)"
                            placeholder="博士四年级生活费"></el-input>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <div class="chargeSetting-bottom-right-msg">
            <p>
              Tips: 若需查询其他城市或国外的收费标准，请点击<span @click="msgStatus=true">查询</span>。
            </p>
          </div>
        </div>
      </div>
    </div>
    <yh-dialog title="新增"
               :visible.sync="addChildStatus">
      <el-form :model="rel"
               label-width="80px"
               class="yh-small mt-5  text-left "
               ref="relForm"
               :rules="relRules">
        <el-form-item label="姓名"
                      prop="name"
                      class="is-required">
          <el-input v-model="rel.name"
                    size="mini"
                    style="width:200px;"
                    placeholder="请输入姓名，不超过50位"
                    maxlength="50"
                    minlength="2"></el-input>
        </el-form-item>
        <el-form-item label="年龄"
                      prop="age"
                      class="is-required">
          <el-input type="age"
                    v-model="rel.age"
                    size="mini"
                    placeholder="请输入年龄，不超过2位"
                    maxlength="2"
                    style="width:200px;"></el-input>
        </el-form-item>
        <el-form-item label="关系"
                      prop="target">
          <el-select v-model="rel.target"
                     size="mini"
                     style="width:200px;"
                     placeholder="请选择关系">
            <el-option v-for="item in addChildOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=""
                      v-if="isShowBox">
          <el-checkbox v-model="rel.copy"
                       label="复制前一子女费用信息"
                       name="type"></el-checkbox>
        </el-form-item>
        <p style="text-align:right">
          <el-button @click="resetForm"
                     size="small">取消</el-button>
          <el-button type="primary"
                     @click="addChildFn"
                     size="mini">确定
          </el-button>
        </p>
      </el-form>
    </yh-dialog>
    <yh-dialog title="收费标准"
               :visible.sync="msgStatus"
               @close="closedio"
               width="75%">
      <div class="msgTitle">
        <el-radio v-model="radio"
                  label="1">国内</el-radio>
        <el-radio v-model="radio"
                  label="2">国外</el-radio>
      </div>
      <br />
      <div v-if="radio==='1'"
           style="width: 100%;">
        <div class="msg-main-title">
          <p>省份:</p>
          <el-select v-model="msgProvinceSelectValue"
                     size="mini"
                     placeholder="全部"
                     @change="dialogChangeFn(msgProvinceSelectValue)">
            <el-option v-for="(item, i) in msgProvinceSelectOptions"
                       :key="i"
                       :label="item.provinceName"
                       :value="item.provinceId">
            </el-option>
          </el-select>
          <p>城市:</p>
          <el-select v-model="msgCitySelectValue"
                     size="mini"
                     placeholder="全部">
            <el-option v-for="(item, i) in msgCitySelectOptions"
                       :key="i"
                       :label="item.provinceName"
                       :value="item.provinceId">
            </el-option>
          </el-select>
          <el-button type="primary"
                     size="mini"
                     @click="getDialogQueryFn(msgProvinceSelectValue, msgCitySelectValue, currentPage, 1)">查询</el-button>
        </div>
        <div class="msg-main-table">
          <el-table :data="tableData"
                    style="width: 100%">
            <el-table-column align="center"
                             prop="province"
                             label="省份">
            </el-table-column>
            <el-table-column align="center"
                             prop="provinceName"
                             label="城市">
            </el-table-column>
            <el-table-column label="幼儿园"
                             align="center">
              <el-table-column align="center"
                               prop="kindergartemSchool"
                               label="学费"
                               width="130">
                <template slot-scope="scope">
                  <span>{{scope.row.kindergartemSchool | addMoneyFilter}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center"
                               prop="kindergartemLife"
                               label="生活费"
                               width="130">
                <template slot-scope="scope">
                  <span>{{scope.row.kindergartemLife | addMoneyFilter}}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="小学"
                             align="center">
              <el-table-column align="center"
                               prop="primarySchool"
                               label="学费"
                               width="130">
                <template slot-scope="scope">
                  <span>{{scope.row.primarySchool | addMoneyFilter}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center"
                               prop="primaryLife"
                               label="生活费"
                               width="130">
                <template slot-scope="scope">
                  <span>{{scope.row.primaryLife | addMoneyFilter}}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="初中"
                             align="center">
              <el-table-column align="center"
                               prop="juniorHighSchool"
                               label="学费"
                               width="130">
                <template slot-scope="scope">
                  <span>{{scope.row.juniorHighSchool | addMoneyFilter}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center"
                               prop="juniorHighLife"
                               label="生活费"
                               width="130">
                <template slot-scope="scope">
                  <span>{{scope.row.juniorHighLife | addMoneyFilter}}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="高中"
                             align="center">
              <el-table-column align="center"
                               prop="seniorHighSchool"
                               label="学费"
                               width="130">
                <template slot-scope="scope">
                  <span>{{scope.row.seniorHighSchool | addMoneyFilter}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center"
                               prop="seniorHighLife"
                               label="生活费"
                               width="130">
                <template slot-scope="scope">
                  <span>{{scope.row.seniorHighLife | addMoneyFilter}}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="大学"
                             align="center">
              <el-table-column align="center"
                               prop="universitySchool"
                               label="学费"
                               width="130">
                <template slot-scope="scope">
                  <span>{{scope.row.universitySchool | addMoneyFilter}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center"
                               prop="universityLife"
                               label="生活费"
                               width="130">
                <template slot-scope="scope">
                  <span>{{scope.row.universityLife | addMoneyFilter}}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="硕士"
                             align="center">
              <el-table-column align="center"
                               prop="maSchool"
                               label="学费"
                               width="130">
                <template slot-scope="scope">
                  <span>{{scope.row.universitySchool | addMoneyFilter}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center"
                               prop="maLife"
                               label="生活费"
                               width="130">
                <template slot-scope="scope">
                  <span>{{scope.row.universityLife | addMoneyFilter}}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="博士"
                             align="center">
              <el-table-column align="center"
                               prop="drSchool"
                               label="学费"
                               width="130">
                <template slot-scope="scope">
                  <span>{{scope.row.universitySchool | addMoneyFilter}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center"
                               prop="drLife"
                               label="生活费"
                               width="130">
                <template slot-scope="scope">
                  <span>{{scope.row.universityLife | addMoneyFilter}}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="操作"
                             align="center"
                             fixed="right">
              <template slot-scope="scope">
                <el-button type="text"
                           size="small"
                           @click="importData(scope.row)">导入</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="msg-main-bottom">
            <yh-pagination :page.sync="currentPage"
                           :total="sumCount" />
          </div>
        </div>
      </div>
      <div v-else
           style="margin-top: 2%;width: 100%;">
        <div class="msg-main-table">
          <el-table :data="tableDataOut"
                    style="width: 100%">
            <el-table-column align="center"
                             prop="provinceName"
                             label="国家"
                             width="150">
            </el-table-column>
            <el-table-column label="小学"
                             align="center">
              <el-table-column align="center"
                               prop="primarySchool"
                               label="学费">
                <template slot-scope="scope">
                  <span>{{scope.row.primarySchool | addMoneyFilter}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center"
                               prop="primaryLife"
                               label="生活费">
                <template slot-scope="scope">
                  <span>{{scope.row.primaryLife | addMoneyFilter}}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="初中"
                             align="center">
              <el-table-column align="center"
                               prop="juniorHighSchool"
                               label="学费">
                <template slot-scope="scope">
                  <span>{{scope.row.juniorHighSchool | addMoneyFilter}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center"
                               prop="juniorHighLife"
                               label="生活费">
                <template slot-scope="scope">
                  <span>{{scope.row.juniorHighLife | addMoneyFilter}}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="高中"
                             align="center">
              <el-table-column align="center"
                               prop="seniorHighSchool"
                               label="学费">
                <template slot-scope="scope">
                  <span>{{scope.row.seniorHighSchool | addMoneyFilter}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center"
                               prop="seniorHighLife"
                               label="生活费">
                <template slot-scope="scope">
                  <span>{{scope.row.seniorHighLife | addMoneyFilter}}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="大学"
                             align="center">
              <el-table-column align="center"
                               prop="universitySchool"
                               label="学费">
                <template slot-scope="scope">
                  <span>{{scope.row.universitySchool | addMoneyFilter}}</span>
                </template>
              </el-table-column>
              <el-table-column align="center"
                               prop="universityLife"
                               label="生活费">
                <template slot-scope="scope">
                  <span>{{scope.row.universityLife | addMoneyFilter}}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="操作"
                             align="center"
                             fixed="right">
              <template slot-scope="scope">
                <el-button type="text"
                           size="small"
                           @click="importData(scope.row)">导入</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </yh-dialog>
    <yh-dialog title="更新子女列表"
               :visible.sync="createdDialog">
      <p>当前子女相关信息有变化，更新后将初始化子女费用信息，是否更新？</p>
      <span slot="footer">
        <el-button size="small"
                   @click="createdDialog = false">取消</el-button>
        <el-button size="small"
                   type="primary"
                   @click="updateGetSaveAllChildInfoFn">更新</el-button>
      </span>
    </yh-dialog>
  </div>
</template>
<script>
export default {
  name: 'dataCollection',
  props: {
    dialogStatus: {
      type: String,
      default: '0',
    },
  },
  data() {
    const validatorAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入年龄'));
      }
      if (value.toString().length > 1) {
        if (
          value.toString().slice(0, 1) === '0'
          && value.toString().slice(1, 2) !== '.'
        ) {
          return callback('首位不为零');
        }
      }
      if (!/^\d+$/g.test(value) || value === '0') {
        return callback('请输入正整数');
      }
      if (value.toString().length > 3) {
        return callback('年龄不可超过3位');
      }

      return callback();
    };
    const validatorName = (rule, value, callback) => {
      console.log(value, '姓名');
      if (value === '') {
        return callback(new Error('请输入成员姓名'));
      }
      if (/[^a-zA-Z\u4E00-\u9FA5.]/.test(value)) {
        return callback('成员姓名不可包含特殊符号和数字');
      }
      if (value.length > 50) {
        return callback('成员姓名不可超过50位');
      }
      return callback();
    };
    const validatorTarget = (rule, value, callback) => {
      if (!value) {
        return callback('请选择关系');
      }
      return callback();
    };
    return {
      isShowBox: false, // 是否显示复制子女的选项
      // 教育储蓄金
      educationReserve: {
        currentMoney: 0,
        monthMoney: 0,
        expectedRevenue: 0,
      },
      educationReserveText: {
        currentMoney: {
          currentMoneyText: '',
          currentMoneyStatus: false,
        },
        monthMoney: {
          monthMoneyText: '',
          monthMoneyStatus: false,
        },
        expectedRevenue: {
          expectedRevenueText: '',
          expectedRevenueStatus: false,
        },
      },
      kidName: 0, // 儿女名字的索引，判断当前是哪个孩子，默认是第一个
      // 刚进页面判断有没有孩子
      createdChildrenStatus: false,
      // 教育费用配置
      editableTabsValue: '0', // tab下 当前是哪个孩子的下标
      // 大宝 二宝数据
      editableTabs: [
        {
          childCostInfoList: [{ moneyTotal: 0 }, { moneyTotal: 0 }],
        },
      ],
      // 下拉框选择的值 判断右侧数据是否显示
      selectValue: '',
      selectData: [
        {
          value: 0,
          label: '学龄前',
        },
        {
          value: 1,
          label: '幼儿园小班',
        },
        {
          value: 2,
          label: '幼儿园中班',
        },
        {
          value: 3,
          label: '幼儿园大班',
        },
        {
          value: 4,
          label: '小学一年级',
        },
        {
          value: 5,
          label: '小学二年级',
        },
        {
          value: 6,
          label: '小学三年级',
        },
        {
          value: 7,
          label: '小学四年级',
        },
        {
          value: 8,
          label: '小学五年级',
        },
        {
          value: 9,
          label: '小学六年级',
        },
        {
          value: 10,
          label: '初中一年级',
        },
        {
          value: 11,
          label: '初中二年级',
        },
        {
          value: 12,
          label: '初中三年级',
        },
        {
          value: 13,
          label: '高中一年级',
        },
        {
          value: 14,
          label: '高中二年级',
        },
        {
          value: 15,
          label: '高中三年级',
        },
        {
          value: 16,
          label: '大学一年级',
        },
        {
          value: 17,
          label: '大学二年级',
        },
        {
          value: 18,
          label: '大学三年级',
        },
        {
          value: 19,
          label: '大学四年级',
        },
        {
          value: 20,
          label: '硕士一年级',
        },
        {
          value: 21,
          label: '硕士二年级',
        },
        {
          value: 22,
          label: '硕士三年级',
        },
        {
          value: 23,
          label: '博士一年级',
        },
        {
          value: 24,
          label: '博士二年级',
        },
        {
          value: 25,
          label: '博士三年级',
        },
        {
          value: 26,
          label: '博士四年级',
        },
        {
          value: 27,
          label: '已毕业',
        },
      ],
      // 教育费用概览环形图参数
      chargeOverviewDataObj: {
        childCount: '',
        lifeCostTotal: '',
        schoolCostTotal: '',
      },
      chargeOverviewData: {},
      chargeOverviewDataShow: false,
      // 教育费用配置环形图参数
      chargeOverviewData2: {},
      chargeOverviewData2Show: false,
      // 判断孩子多少年后入学提示是否显示
      enterSchoolYearCode: false,
      enterSchoolYearText: '',
      // 孩子数据
      children: {
        // 孩子默认学费 生活费
        listFirst: {
          kindergartemLife: '',
          kindergartemSchool: '',
          primaryLife: '',
          primarySchool: '',
          seniorHighLife: '',
          seniorHighSchool: '',
          juniorHighLife: '',
          juniorHighSchool: '',
          universityLife: '',
          universitySchool: '',
          maLife: '',
          maSchool: '',
          drSchool: '',
          drLife: '',
        },
        listSecond: [
          {
            childrenType: 1,
            class1: 0,
            class2: 0,
            class3: 0,
            class4: 0,
            class5: 0,
            class6: 0,
            class7: 0,
            class8: 0,
            class9: 0,
            class10: 0,
            class11: 0,
            class12: 0,
            class13: 0,
            class14: 0,
            class15: 0,
            class16: 0,
            class17: 0,
            class18: 0,
            class19: 0,
            class20: 0,
            class21: 0,
            class22: 0,
            class23: 0,
            class24: 0,
            class25: 0,
            class26: 0,
            moneyCost1: 0,
            moneyCost2: 0,
            moneyCost3: 0,
            moneyCost4: 0,
            moneyCost5: 0,
            moneyTotal: 0,
          },
          {
            childrenType: 2,
            class1: 0,
            class2: 0,
            class3: 0,
            class4: 0,
            class5: 0,
            class6: 0,
            class7: 0,
            class8: 0,
            class9: 0,
            class10: 0,
            class11: 0,
            class12: 0,
            class13: 0,
            class14: 0,
            class15: 0,
            class16: 0,
            class17: 0,
            class18: 0,
            class19: 0,
            class20: 0,
            class21: 0,
            class22: 0,
            class23: 0,
            class24: 0,
            class25: 0,
            class26: 0,
            moneyCost1: 0,
            moneyCost2: 0,
            moneyCost3: 0,
            moneyCost4: 0,
            moneyCost5: 0,
            moneyTotal: 0,
          },
        ],
      },
      // 当前获得焦点的input
      inputFocus: {
        className: '',
        inputVal: '',
        costName: '',
        hierarchy: '',
      },
      // 收费标准查询弹窗状态
      msgStatus: false,
      // 收费标准查询弹窗当选按钮状态
      radio: '1',
      // 收费标准查询国内省份下拉框
      msgProvinceSelectValue: '',
      // 点击查询后赋值
      msgProvinceSelectValueAffirmative: '',
      // 国内 省份
      msgProvinceSelectOptions: [
        {
          provinceName: '全部',
          provinceId: '0',
        },
      ],
      msgCitySelectValue: '',
      // 点击查询后赋值
      msgCitySelectValueAffirmative: '',
      // 城市
      msgCitySelectOptions: [
        {
          provinceName: '全部',
          provinceId: '0',
        },
      ],
      // 新增孩子弹窗状态
      addChildStatus: false,
      // 新增孩子表格验证
      relRules: {
        name: [{ required: true, validator: validatorName, trigger: ['blur'] }],
        age: [{ required: true, validator: validatorAge, trigger: ['blur'] }],
        target: [
          // required: true, message: '请选择关系', trigger: 'blur',
          { required: true, validator: validatorTarget, trigger: ['blur'] },
        ],
      },
      rel: {
        name: '', // 关系姓名
        age: null,
        target: '', // 对应关系
        copy: '', // 是否复制前一个子女信息
      },
      addChildOptions: [
        {
          label: '儿子',
          value: '4',
        },
        {
          label: '女儿',
          value: '5',
        },
      ],
      // 表格数据
      tableData: [],
      // 国外
      tableDataOut: [],
      currentPage: 1,
      pageSize: 10,
      sumCount: 0,
      // 初始化时候的弹窗
      createdDialog: false,
      //  从session取客户信息
      cust: {},
      childrenCheckedMa: false, // 硕士是否选中
      childrenCheckedDr: false, // 博士是否选中
      childrenSelectMaData: '1', // 硕士下拉框选择值
      childrenSelectMaList: [
        {
          label: '硕士(2年制)',
          value: '1',
        },
        {
          label: '硕士(3年制)',
          value: '2',
        },
      ], // 硕士下拉框
      childrenSelectDrData: '1', // 博士士下拉框选择值
      childrenSelectDrList: [
        {
          label: '博士(3年制)',
          value: '1',
        },
        {
          label: '博士(4年制)',
          value: '2',
        },
      ], // 博士下拉框
      savings: {},
      educationExpenses: {},
      stage: {},
      grade: {},
      tuition: {},
      livingExpenses: {},
    };
  },
  watch: {
    currentPage: {
      immediate: true,
      handler(val) {
        this.getDialogQueryFn(
          this.msgProvinceSelectValueAffirmative,
          this.msgCitySelectValueAffirmative,
          val,
          2,
        );
      },
    },
    chargeOverviewDataObj: {
      immediate: true,
      handler(val) {
        console.log(val, '*********');
        if (
          this.chargeOverviewDataObj.schoolCostTotal === 0
          && this.chargeOverviewDataObj.lifeCostTotal === 0
        ) {
          this.$emit('toNextStepDisabled', true, this.editableTabs, 1);
        } else {
          this.$emit('toNextStepDisabled', false, this.editableTabs, 1);
        }
      },
    },
    createdChildrenStatus: {
      // 控制添加按钮的显示
      immediate: true,
      handler(val) {
        if (val) {
        }
      },
    },
    // children: {
    //   immediate: true,
    //   deep: true,
    //   handler(val) {
    //     console.log('监听右边表格', val);
    //     // eslint-disable-next-line no-restricted-syntax
    //     for (const i in val) {
    //       console.log('i',i)
    //       if (i === 'juniorHighLife' || i === 'juniorHighSchool' || i === 'kindergartemLife' ||
    //         i === 'kindergartemSchool' || i === 'preschoolerLife' || i === 'preschoolerSchool' || i === 'primaryLife' || i === 'primarySchool'
    //         || i === 'seniorHighLife' || i === 'seniorHighSchool' || i === 'universityLife' || i === 'universitySchool') {
    //         // eslint-disable-next-line no-param-reassign
    //         val[i] = this.moneyFilter(val[i].toString());
    //         console.log(val[i])
    //       }
    //     }
    //     console.log('监听右边表格2', val);
    //   },
    // },
    msgStatus: {
      handler(val) {
        console.log(val);
        if (val === false) {
          this.msgProvinceSelectValue = '';
          this.msgCitySelectValue = '';
          this.msgProvinceSelectValueAffirmative = '';
          this.msgCitySelectValueAffirmative = '';
          this.pageNo = 1;
          this.currentPage = 1;
          this.radio = '1';
        } else {
          this.getDialogQueryOutFn();
          this.getDialogQueryFn('000000', '', this.currentPage);
        }
      },
    },
  },
  created() {
    this.cust = JSON.parse(sessionStorage.getItem('custInfo'));
    const parame = {
      data: {
        cis: this.cust.cis,
        uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
      },
    };
    // 查询教育储蓄金
    this.getSaveChildEduReserveFn(parame);
    const a = {
      data: {
        cis: this.cust.cis,
        flagFrom: this.dialogStatus,
        uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
      },
    };
    // 查询费用配置
    this.getSaveAllChildInfoFn(a, 'list');
    const dialogParame = {
      data: {
        parentId: '000000',
        countryType: '1',
        uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
      },
    };
    // 查询全国收费标准下拉框数据
    this.getDialogSelectFn(dialogParame);
    // 查询全国收费标准表格数据 -- 查省份
    this.getDialogQueryFn('000000', '', this.currentPage);
    this.getDialogQueryOutFn();
  },
  beforeDestroy() {},
  directives: {
    numberOnly: {
      bind(el) {
        // eslint-disable-next-line no-param-reassign
        el.handler = function () {
          // el.value = Number(el.value.replace(/\D+/, ''));
          if (!/^[0-9]{1}$/.test(el.value)) {
            // eslint-disable-next-line no-param-reassign
            el.value = el.value.slice(0, 1);
          }
        };
        el.addEventListener('input', el.handler);
      },
      unbind(el) {
        el.removeEventListener('input', el.handler);
      },
    },
  },
  mounted() {
    this.aa();
  },
  methods: {
    aa() {
      const parames = {
        data: {
          tipsIdentif: [
            'savings',
            'educationExpenses',
            'stage',
            'grade',
            'tuition',
            'livingExpenses',
          ],
        },
      };
      this.$_post(this.$API.get_by_identif, parames).then((res) => {
        const arr = res.data.list;
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].tipsIdentif === 'savings') {
            this.savings = arr[i];
          }
          if (arr[i].tipsIdentif === 'educationExpenses') {
            this.educationExpenses = arr[i];
          }
          if (arr[i].tipsIdentif === 'stage') {
            this.stage = arr[i];
          }
          if (arr[i].tipsIdentif === 'grade') {
            this.grade = arr[i];
          }
          if (arr[i].tipsIdentif === 'tuition') {
            this.tuition = arr[i];
          }
          if (arr[i].tipsIdentif === 'livingExpenses') {
            this.livingExpenses = arr[i];
          }
        }
      });
    },
    // 收费标准中数据导入
    importData(data) {
      console.log('导入的数据', data);
      if (this.createdChildrenStatus) {
        const nameArr = [];
        const costArr = [];
        for (const i in this.children.listFirst) {
          // eslint-disable-next-line guard-for-in,no-restricted-syntax
          for (const j in data) {
            if (i === j) {
              // console.log('val', this.children.listFirst[i]);
              nameArr.push(i);
              costArr.push(this.disMoneyFilter(data[j]));
              // this.children.listFirst[i]=this.disMoneyFilter(data[j]);
            }
          }
        }
        const parames = {
          data: {
            cis: this.cust.cis,
            id: this.editableTabs[this.editableTabsValue].id,
            columnNames: nameArr,
            costs: costArr,
          },
        };
        console.log('导入参数', parames);
        this.$_post(this.$API.importData, parames).then((res) => {
          console.log('返回的数据', res);
          if (res.data.childList.length === 0) {
            this.createdChildrenStatus = false;
            this.$emit('toNextStepDisabled', true, res.data.childList, 1);
          } else {
            this.createdChildrenStatus = true;
            this.$emit('toNextStepDisabled', false, res.data.childList, 1);
          }
          // 2 表示数据导入
          this.toConfigureData(res, 2);
          this.msgStatus = false;
        });
      }
    },
    // 保留两位小数，增加千分符
    moneyFilter2(x) {
      if (`${x}`.indexOf(',') !== -1) {
        return x;
      }
      // 将入参x转换成float类型的小数。假设入参为100000
      const f = parseFloat(x);
      // 如果为空则返回默认值
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(f)) {
        return '';
      }
      // 将入参四舍五入并保留两位小数
      const f2 = Math.round(x * 100) / 100;
      // 将四舍五入后的入参转为字符类型
      let s = f2.toString();
      // 筛选该入参中是否有小数点 有则返回小数点的位置，没有则返回-1
      let rs = s.indexOf('.');
      // 小于0，代表该入参没有小数点，所以该入参为整数
      if (rs < 0) {
        // 将入参的长度赋值给rs
        rs = s.length;
        // 在入参后连上小数点
        s += '.';
      }
      // 循环在入参后补 100000.00
      while (s.length <= rs + 2) {
        s += '0';
      }
      // 将入参根据小数点分割成两部分。分割后为100000和00。
      const parts = s.toString().split('.');
      // parts[0]为取左边整数位。是正则表达式，如果整数位大于3，就在后边添加逗号(千分符)
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      // 重新拼起来 100,000.00
      return parts.join('.');
    },
    // 保留两位小数，增加千分符
    moneyFilter(x) {
      if (`${x}`.indexOf(',') !== -1) {
        return x;
      }
      // 将入参x转换成float类型的小数。假设入参为100000
      const f = parseFloat(x);
      // 如果为空则返回默认值
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(f)) {
        return '0.00';
      }
      // 将入参四舍五入并保留两位小数
      const f2 = Math.round(x * 100) / 100;
      // 将四舍五入后的入参转为字符类型
      let s = f2.toString();
      // 筛选该入参中是否有小数点 有则返回小数点的位置，没有则返回-1
      let rs = s.indexOf('.');
      // 小于0，代表该入参没有小数点，所以该入参为整数
      if (rs < 0) {
        // 将入参的长度赋值给rs
        rs = s.length;
        // 在入参后连上小数点
        s += '.';
      }
      // 循环在入参后补 100000.00
      while (s.length <= rs + 2) {
        s += '0';
      }
      // 将入参根据小数点分割成两部分。分割后为100000和00。
      const parts = s.toString().split('.');
      // parts[0]为取左边整数位。是正则表达式，如果整数位大于3，就在后边添加逗号(千分符)
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      // 重新拼起来 100,000.00
      return parts.join('.');
    },
    // 去掉千分符
    disMoneyFilter(x) {
      if (x.toString().indexOf(',') === -1) {
        return x;
      }
      return x.toString().replace(new RegExp(',', 'g'), '');
    },
    schoolLeveFilterFn(data) {
      let msg;
      switch (data) {
        case 1:
          msg = '幼儿园';
          break;
        case 2:
          msg = '小学';
          break;
        case 3:
          msg = '初中';
          break;
        case 4:
          msg = '高中';
          break;
        case 5:
          msg = '大学';
          break;
        case 6:
          msg = '硕士';
          break;
        case 7:
          msg = '博士';
          break;
        default:
          msg = '';
      }
      return msg;
    },
    // 取消新增子女弹框
    resetForm() {
      this.$refs.relForm.resetFields();
      this.addChildStatus = false;
    },
    // 新增子女方法
    addChildFn() {
      console.log('原来的数据', this.children);
      this.$refs.relForm.validate((valid) => {
        if (valid) {
          console.log(this.rel, 'rrrr');
          const params = {
            data: {
              cis: this.cust.cis,
              custName: this.rel.name,
              custAge: this.rel.age,
              custRelation: this.rel.target,
              isCopyLastChild: this.rel.copy === true ? 1 : 2,
              uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
            },
          };
          this.getSaveAllChildInfoFn(params, 'add');
          this.addChildStatus = false;
          this.$refs.relForm.resetFields();
        }
      });
    },
    // 删除孩子侧边栏方法
    removeTab(i) {
      this.$confirm(`确定要删除${this.editableTabs[i].custName}吗？`, '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          const params = {
            data: {
              cis: this.cust.cis,
              id: this.editableTabs[i].id,
              uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
            },
          };
          this.getSaveAllChildInfoFn(params, 'delete');
        })
        .catch(() => {
          console.log('点击取消');
        });
    },

    // 额外费用校验输入正负数， 保留2位小数 调用公共方法
    RestrictedMoney(values) {
      return this.plusOrMinus(values.toString());
    },
    RestrictedMoney3(values) {
      return this.plusOrMinus3(values.toString(), 2);
    },
    RestrictedMoney2(values) {
      return this.plusOrMinus2(values.toString());
    },
    // 结合change事件对失去焦点进行判断，防止输入一些无效值
    materielExtraCostChange(item) {
      console.log('change===', item);
      // 防止删除为空
      if (!item) {
        // eslint-disable-next-line no-param-reassign
        item = '0.00';
      }
      // 一些错误金额输入的判断
      if (
        item.toString().indexOf('.') > 0
        && Number(item.toString().split('.')[1].length) < 1
      ) {
        // eslint-disable-next-line no-param-reassign,prefer-destructuring
        item = item.toString().split('.')[0];
      }
      // 一些错误金额输入的判断
      if (!item || item === '-' || item === '-0') {
        // eslint-disable-next-line no-param-reassign
        item = '0.00';
        return;
      }
      // eslint-disable-next-line no-param-reassign
      item = parseFloat(item).toFixed(2);
      // 此时item.materielExtraCost的值即是最终有效值
    },
    materielExtraCostChange2(item) {
      // 防止删除为空
      if (!item) {
        // eslint-disable-next-line no-param-reassign
        item = '0.00';
      }
      // 一些错误金额输入的判断
      if (
        item.toString().indexOf('.') > 0
        && Number(item.toString().split('.')[1].length) < 1
      ) {
        // eslint-disable-next-line no-param-reassign,prefer-destructuring
        item = item.toString().split('.')[0];
      }
      // 一些错误金额输入的判断
      if (!item || item === '-' || item === '-0') {
        // eslint-disable-next-line no-param-reassign
        item = '0.00';
        return;
      }
      // eslint-disable-next-line no-param-reassign
      item = parseFloat(item).toFixed(2);
      // 此时item.materielExtraCost的值即是最终有效值
      console.warn('22222', item);
      // this.item = item;
    },
    plusOrMinus(values) {
      console.log(values, '--values');
      let newValue;
      if (!/[^0-9.]/g.test(values)) {
        // eslint-disable-next-line no-useless-escape
        newValue = values
          .replace(/[^\-\d.]/g, '')
          .replace(/\-{2,}/g, '-')
          .replace(/^\./g, '')
          .replace(/\.{2,}/g, '.')
          .replace('.', '$#$')
          .replace(/\./g, '')
          .replace('$#$', '.');
        if (
          newValue.toString().indexOf('.') > 0
          && Number(newValue.toString().split('.')[1].length) > 2
        ) {
          // eslint-disable-next-line radix
          newValue = parseInt(parseFloat(newValue) * 100) / 100;
        }
        if (newValue.toString().split('-').length - 1 > 1) {
          newValue = parseFloat(newValue) || '';
        }
        if (
          newValue.toString().split('-').length > 1
          && newValue.toString().split('-')[0].length > 0
        ) {
          newValue = parseFloat(newValue) || '';
        }
        if (
          newValue.toString().length > 1
          && (newValue.toString().charAt(0) === '0'
            || (newValue.toString().length > 2
              && newValue.toString().charAt(0) === '-'
              && newValue.toString().charAt(1) === '0'
              && newValue.toString().charAt(2) !== '.'))
          && newValue.toString().indexOf('.') < 1
        ) {
          newValue = parseFloat(newValue) || '';
        }
        // 判断整数位最多为8位
        if (
          newValue.toString().indexOf('.') > 0
          && Number(newValue.toString().split('.')[0].length) > 8
        ) {
          newValue = `${newValue.toString().substring(0, 8)}.${
            newValue.toString().split('.')[1]
          }`;
        } else if (
          newValue.toString().indexOf('.') < 0
          && Number(newValue.toString().split('.')[0].length) > 8
        ) {
          newValue = newValue.toString().substring(0, 8);
        }
      } else {
        newValue = values.replace(/[^0-9.]/g, '');
      }
      console.log(newValue, '--newValue');
      return newValue;
    },
    plusOrMinus2(values) {
      console.log(values, '--values');
      let newValue;
      if (!/[^0-9.]/g.test(values)) {
        // eslint-disable-next-line no-useless-escape
        newValue = values
          .replace(/[^\-\d.]/g, '')
          .replace(/\-{2,}/g, '-')
          .replace(/^\./g, '')
          .replace(/\.{2,}/g, '.')
          .replace('.', '$#$')
          .replace(/\./g, '')
          .replace('$#$', '.');
        if (
          newValue.toString().indexOf('.') > 0
          && Number(newValue.toString().split('.')[1].length) > 2
        ) {
          // eslint-disable-next-line radix
          newValue = parseInt(parseFloat(newValue) * 100) / 100;
        }
        if (newValue.toString().split('-').length - 1 > 1) {
          newValue = parseFloat(newValue) || '';
        }
        if (
          newValue.toString().split('-').length > 1
          && newValue.toString().split('-')[0].length > 0
        ) {
          newValue = parseFloat(newValue) || '';
        }
        if (
          newValue.toString().length > 1
          && (newValue.toString().charAt(0) === '0'
            || (newValue.toString().length > 2
              && newValue.toString().charAt(0) === '-'
              && newValue.toString().charAt(1) === '0'
              && newValue.toString().charAt(2) !== '.'))
          && newValue.toString().indexOf('.') < 1
        ) {
          newValue = parseFloat(newValue) || '';
        }
        // 判断整数位最多为3位
        if (
          newValue.toString().indexOf('.') > 0
          && Number(newValue.toString().split('.')[0].length) > 3
        ) {
          newValue = `${newValue.toString().substring(0, 3)}.${
            newValue.toString().split('.')[1]
          }`;
        } else if (
          newValue.toString().indexOf('.') < 0
          && Number(newValue.toString().split('.')[0].length) > 3
        ) {
          newValue = newValue.toString().substring(0, 3);
        }
      } else {
        newValue = values.replace(/[^0-9.]/g, '');
      }
      return newValue;
    },
    plusOrMinus3(val, precision) {
      let result;
      if (precision === 0) {
        result = val.replace(/[^\d]/g, ''); // 整数
      } else {
        console.log(result);
        result = val.replace(/[^\d.]/g, ''); // 清除“数字”和“.”以外的字符
        console.log(result, 'dd清楚没');
      }
      result = result.replace(/\.{2,}/g, '.'); // 只保留第一个. 清除多余的
      result = result
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.');
      if (precision !== null && precision !== 0) {
        const reg = new RegExp(`^(-)*(\\d+)\\.(\\d{${precision}}).*$`, 'g');
        result = result.replace(reg, '$1$2.$3');
      }
      if (result.indexOf('.') < 0 && result !== '') {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        result = parseFloat(result);
      }
      // 判断整数位最多为7位
      if (
        result.toString().indexOf('.') > 0
        && Number(result.toString().split('.')[0].length) > 7
      ) {
        result = `${result.toString().substring(0, 7)}.${
          result.toString().split('.')[1]
        }`;
      } else if (
        result.toString().indexOf('.') < 0
        && Number(result.toString().split('.')[0].length) > 7
      ) {
        result = result.toString().substring(0, 7);
      }
      return result;
    },
    // 关闭弹窗
    closedio() {
      this.msgStatus = false;
    },
    getSaveChildEduReserveFn(parames) {
      this.$_post(this.$API.getSaveChildEduReserve, parames).then((res) => {
        this.educationReserve = res.data.info;
        this.$emit('toEducationReserve', this.educationReserve);
        // eslint-disable-next-line no-restricted-syntax,guard-for-in
        for (const i in this.educationReserve) {
          if (
            i === 'currentMoney'
            || i === 'monthMoney'
            || i === 'expectedRevenue'
          ) {
            // this.educationReserve[i] = Number(this.moneyFilter(this.educationReserve[i]));
            this.educationReserve[i] = this.moneyFilter(
              this.educationReserve[i],
            );
          }
        }
        console.log('educationReserve', this.educationReserve.currentMoney);
        console.log(
          'educationReserve',
          typeof this.educationReserve.currentMoney,
        );
      });
    },
    getSaveAllChildInfoFn(parames, status) {
      let ajaxUrl;
      if (status === 'list') {
        ajaxUrl = this.$API.getSaveAllChildInfo;
      } else if (status === 'add') {
        ajaxUrl = this.$API.addSaveChildInfo;
      } else if (status === 'save') {
        ajaxUrl = this.$API.getSaveAllChildSaveInfo;
      } else if (status === 'delete') {
        ajaxUrl = this.$API.deleteSaveChildInfo;
        this.editableTabsValue = '0';
      }
      // ajaxUrl 判断是从哪里调用方法
      this.$_post(ajaxUrl, parames)
        .then((res) => {
          console.log('子女接口--------', res);
          if (status === 'add') {
            if (res.errorCode === 'E00000') {
              this.$message.success('成功!');
              // 新增成功后显示教育费用概览的子女
              this.createdChildrenStatus = true;
              this.$emit('toNextStepDisabled', false, res.data.childList, 1);
              console.log(this.educationReserve, '******************');
              console.warn(
                this.createdChildrenStatus,
                '新增成功后显示教育费用概览的子女',
              );
            } else if (res.errorCode === 'WP01007') {
              this.$message.error(res.errorMsg);
              return;
            } else if (res.errorCode === 'WP01006') {
              this.$message.error(res.errorMsg);
              return;
            } else {
              this.$message.error(res.errorMsg);
              return;
            }
          } else if (status === 'delete') {
            if (res.errorCode === 'E00000') {
              this.$message.success('删除成功!');
              if (res.data.childList.length === 0) {
                this.createdChildrenStatus = false;
                this.$emit('toNextStepDisabled', true, res.data.childList, 1);
              }
            } else if (res.errorCode === 'E00024') {
              this.$message.success(res.errorMsg);
            }
          } else if (status === 'list') {
            if (res.errorCode === 'E00000') {
              if (res.data.childList.length === 0) {
                this.createdChildrenStatus = false;
                this.$emit('toNextStepDisabled', true, res.data.childList, 1);
              }
            }
          } else if (status === 'save') {
            if (res.errorCode === 'E00000') {
              if (res.data.childList.length === 0) {
                this.createdChildrenStatus = false;
                this.$emit('toNextStepDisabled', true, res.data.childList, 1);
              } else {
                this.createdChildrenStatus = true;
                this.$emit('toNextStepDisabled', false, res.data.childList, 1);
              }
            }
          }
          for (let i = 0; i < res.data.childList.length; i++) {
            if (res.data.childList[i].currentSchool < 6) {
              this.isShowBox = true;
              break;
            }
          }
          // 1 表示初始化数据
          this.toConfigureData(res, 1);
        })
        .catch(e => console.log(e));
    },
    toConfigureData(res, num) {
      this.editableTabs = res.data.childList;
      console.log('editableTabs', this.editableTabs);
      console.log('children', this.children);
      if (res.data.msgTip === '1') {
        // 0是不弹加载list接口数据，弹窗点确定请求save接口,取消则还是list接口数据
        this.createdDialog = true;
      }
      // 判断有没有孩子
      if (res.data.childList.length > 0) {
        this.createdChildrenStatus = true;
      } else {
        this.createdChildrenStatus = false;
        return;
      }
      this.chargeOverviewDataObj = {
        childCount: res.data.childCount,
        lifeCostTotal: res.data.childTotalCostInfo.lifeCostTotal,
        schoolCostTotal: res.data.childTotalCostInfo.schoolCostTotal,
      };
      if (this.editableTabs[this.editableTabsValue].enterSchoolYear === '') {
        this.enterSchoolYearCode = true;
        this.enterSchoolYearText = '请输入预计入学时间';
      } else {
        this.enterSchoolYearCode = false;
        this.enterSchoolYearText = '';
      }
      // 下面是渲染孩子总共的教育费用概览
      // 教育费用概览环形图参数
      const chartData = this.renderChargeOverviewDataFn(
        res.data.childTotalCostInfo.costTotalSmu,
      );
      console.log(chartData, '------------chartData');
      this.chargeOverviewData = chartData;
      this.chargeOverviewDataShow = true;
      // 存入session给第四步用
      sessionStorage.setItem(
        'childEduChargeOverviewData',
        JSON.stringify(chartData),
      );
      // // selectValue 控制右边表格显示多少年级
      this.selectValue = res.data.childList[this.editableTabsValue].currentClass;
      console.log('当前***', this.selectValue);
      // // 已经毕业下面不用走了
      if (this.selectValue >= 20) {
        return;
      }
      // console.log('当前***editableTabsValue', this.editableTabsValue);

      // // 以下是教育费用配置
      // // 进页面默认展示第一个孩子的数据图
      const chartData2 = this.renderChargeOverviewData2Fn(
        res.data.childList[0].custSumList,
      );
      console.log(chartData2, 'chartData2');
      this.chargeOverviewData2 = chartData2;
      this.chargeOverviewData2Show = true;
      if (this.editableTabs.maEduSys !== '0') {
        this.childrenCheckedMa = true;
        this.childrenSelectMaData = this.editableTabs[this.kidName].maEduSys;
      }
      if (this.editableTabs.drEduSys !== '0') {
        this.childrenCheckedDr = true;
        this.childrenSelectDrData = this.editableTabs[this.kidName].drEduSys;
      }
      // 以下是教育费用配置孩子的侧边栏
      // 下面两个for循环给右边表格数据补 .00
      this.editableTabs.forEach((val) => {
        val.childCostInfoList.forEach((v) => {
          // eslint-disable-next-line no-restricted-syntax
          for (const i in v) {
            if (v[i].toString().indexOf('.') === -1) {
              // eslint-disable-next-line no-param-reassign
              v[i] = `${v[i]}.00`;
            }
          }
        });
      });
      this.editableTabs.forEach((z) => {
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const i in z.planEduDefultParam) {
          if (z.planEduDefultParam[i].toString().indexOf('.') === -1) {
            // eslint-disable-next-line no-param-reassign
            z.planEduDefultParam[i] = `${z.planEduDefultParam[i]}.00`;
          }
        }
      });
      // eslint-disable-next-line no-restricted-syntax
      for (const i in this.educationReserve) {
        if (
          i === 'currentMoney'
          || i === 'monthMoney'
          || i === 'expectedRevenue'
        ) {
          if (this.educationReserve[i] === '') {
            this.$emit('toNextStepDisabled', true, res.data.childList, 1);
            return;
          }
          this.$emit('toNextStepDisabled', false, res.data.childList, 1);
        }
      }
      console.log('千叶字符####', res.data);
      // 以下是获取孩子的右边表格数据 进页面取第一个孩子
      // this.children.listFirst = res.data.childList[0].planEduDefultParam;
      // this.children.listSecond = res.data.childList[0].childCostInfoList;
      if (num === 2) {
        for (let index = 0; index < this.editableTabs.length; index++) {
          if (this.kidName * 1 === index) {
            this.increaseMoneyFilter(
              this.editableTabs[index].childCostInfoList,
              2,
            );
            this.increaseMoneyFilter(
              this.editableTabs[index].planEduDefultParam,
              1,
            );
          }
        }
      } else {
        this.increaseMoneyFilter(res.data.childList[0].planEduDefultParam, 1);
        this.increaseMoneyFilter(res.data.childList[0].childCostInfoList, 2);
      }
    },
    // 给右边数据加千分符
    increaseMoneyFilter(v, i) {
      const arr = v;
      if (i === 1) {
        arr.juniorHighLife = this.moneyFilter(arr.juniorHighLife);
        arr.juniorHighSchool = this.moneyFilter(arr.juniorHighSchool);
        arr.kindergartemLife = this.moneyFilter(arr.kindergartemLife);
        arr.kindergartemSchool = this.moneyFilter(arr.kindergartemSchool);
        arr.preschoolerLife = this.moneyFilter(arr.preschoolerLife);
        arr.preschoolerSchool = this.moneyFilter(arr.preschoolerSchool);
        arr.primaryLife = this.moneyFilter(arr.primaryLife);
        arr.primarySchool = this.moneyFilter(arr.primarySchool);
        arr.seniorHighLife = this.moneyFilter(arr.seniorHighLife);
        arr.seniorHighSchool = this.moneyFilter(arr.seniorHighSchool);
        arr.universityLife = this.moneyFilter(arr.universityLife);
        arr.universitySchool = this.moneyFilter(arr.universitySchool);
        this.children.listFirst = arr;
        console.log(arr, '---失去焦点');
      } else if (i === 2) {
        // eslint-disable-next-line no-plusplus,no-shadow
        for (let i = 0; i < arr.length; i++) {
          // eslint-disable-next-line guard-for-in,no-restricted-syntax
          for (const y in arr[i]) {
            // eslint-disable-next-line no-plusplus
            for (let l = 1; l < 20; l++) {
              const key = `class${l}`;
              if (y === key) {
                arr[i][y] = this.moneyFilter(arr[i][y]);
              }
            }
          }
        }
        this.children.listSecond = arr;
      }
      console.log(v, '要加千分符的数据');
    },
    ObtainFocus(e) {
      console.log(e.target.value);
      e.target.value = e.target.value
        .toString()
        .replace(new RegExp(',', 'g'), '');
    },
    // input 获得焦点去千分符
    ObtainFocus2(className, inputVal, costName, hierarchy) {
      this.inputFocus = {
        className,
        inputVal,
        costName,
        hierarchy,
      };
      // className输入框的名字，inputVal是值，costName 0是学费 1是生活费，hierarchy 1是外层，2是内层
      console.log(className, inputVal, costName, hierarchy);
      if (hierarchy === 1) {
        // eslint-disable-next-line no-restricted-syntax
        for (const v in this.children.listFirst) {
          if (className === v) {
            this.children.listFirst[v] = this.disMoneyFilter(inputVal);
            console.log(
              '*************************',
              this.children.listFirst[v],
            );
          }
        }
      } else {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.children.listSecond.length; i++) {
          if (costName === 0) {
            // eslint-disable-next-line no-restricted-syntax
            for (const v in this.children.listSecond[0]) {
              if (className === v) {
                this.children.listSecond[0][v] = this.disMoneyFilter(inputVal);
              }
            }
          } else {
            // eslint-disable-next-line no-restricted-syntax
            for (const v in this.children.listSecond[1]) {
              if (className === v) {
                this.children.listSecond[1][v] = this.disMoneyFilter(inputVal);
              }
            }
          }
        }
      }
    },
    // 切换孩子的tabs
    tabsClick(i) {
      this.kidName = i;
      if (this.editableTabs[i].enterSchoolYear === '') {
        this.enterSchoolYearCode = true;
        this.enterSchoolYearText = '请输入预计入学时间';
      } else {
        this.enterSchoolYearCode = false;
        this.enterSchoolYearText = '';
      }
      this.inputFocus = {
        className: '',
        inputVal: '',
        costName: '',
        hierarchy: '',
      };
      if (this.editableTabs[i].currentClass >= 20) {
        // 说明孩子已经毕业了
        this.selectValue = 23;
        this.chargeOverviewData2Show = false;
        return;
      }
      this.chargeOverviewData2Show = true;
      // i是当前切换哪个孩子的下标
      this.selectValue = this.editableTabs[i].currentClass;
      // 以下是切换孩子tab 更换环形图
      const chartData2 = this.renderChargeOverviewData2Fn(
        this.editableTabs[i].custSumList,
      );
      console.log(chartData2, 'chartData2');
      this.chargeOverviewData2 = chartData2;
      this.chargeOverviewData2Show = true;
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < this.editableTabs.length; index++) {
        if (i * 1 === index) {
          this.increaseMoneyFilter(
            this.editableTabs[index].childCostInfoList,
            2,
          );
          this.increaseMoneyFilter(
            this.editableTabs[index].planEduDefultParam,
            1,
          );
        }
      }
      // this.children.listFirst = this.editableTabs[i].planEduDefultParam;
      // this.children.listSecond = this.editableTabs[i].childCostInfoList;
    },
    // 教育储蓄金失去焦点
    educationReserveBlurFn(data, e, num) {
      // data是值，num是第几个Input
      // 为空后爆红提示
      if (!data) {
        if (num === 1) {
          this.educationReserveText.currentMoney.currentMoneyStatus = true;
          this.educationReserveText.currentMoney.currentMoneyText = '请输入已存金额';
        } else if (num === 2) {
          this.educationReserveText.monthMoney.monthMoneyStatus = true;
          this.educationReserveText.monthMoney.monthMoneyText = '请输入每月储蓄金额';
        } else if (num === 3) {
          this.educationReserveText.expectedRevenue.expectedRevenueStatus = true;
          this.educationReserveText.expectedRevenue.expectedRevenueText = '请输入期望收益';
        }
      } else if (num === 1) {
        this.educationReserveText.currentMoney.currentMoneyStatus = false;
        this.educationReserveText.currentMoney.currentMoneyText = '';
      } else if (num === 2) {
        this.educationReserveText.monthMoney.monthMoneyStatus = false;
        this.educationReserveText.monthMoney.monthMoneyText = '';
      } else if (num === 3) {
        this.educationReserveText.expectedRevenue.expectedRevenueStatus = false;
        this.educationReserveText.expectedRevenue.expectedRevenueText = '';
      }
      // 最后一位是 . 就给他截取掉
      let msg = '';
      if (data.toString().charAt(data.length - 1) === '.') {
        msg = data.substring(0, data.length - 1);
      } else {
        msg = data;
      }

      e.target.value = this.moneyFilter2(e.target.value);
      // eslint-disable-next-line no-restricted-syntax
      for (const i in this.educationReserve) {
        if (
          i === 'currentMoney'
          || i === 'monthMoney'
          || i === 'expectedRevenue'
        ) {
          console.log(this.educationReserve[i], '-******************-', i);
          if (!this.educationReserve[i]) {
            this.$emit('toNextStepDisabled', true, this.editableTabs, 1);
            console.log(1);
            return;
          }
          this.$emit('toNextStepDisabled', false, this.editableTabs, 1);
        }
      }
      this.$emit('toEducationReserve', this.educationReserve);
      // 防止已毕业的情况下一步
      const aArr = this.editableTabs.filter(val => val.currentClass >= 20);
      console.log(aArr, '看几个已经 毕业');
      if (aArr.length === this.editableTabs.length) {
        this.$emit('toNextStepDisabled', true, this.editableTabs, 1);
      }
      // this.editableTabs.forEach((val) => {
      //   if (val.currentClass >= 20) {
      //     this.$emit('toNextStepDisabled', true, this.editableTabs, 1);
      //     return;
      //   }
      //   this.$emit('toNextStepDisabled', false, this.editableTabs, 1);
      // });
    },
    // 获取焦点
    educationReserveFocusFn(e) {
      e.target.value = e.target.value.replace(new RegExp(',', 'g'), '');
    },
    selectChange(selectedIndex, index, inputVal) {
      // 避免输入框清空，切换年级在切到学龄前
      if (selectedIndex === 0 && inputVal === undefined) {
        this.selectValue = selectedIndex;
        this.enterSchoolYearCode = true;
        this.enterSchoolYearText = '请输入预计入学时间';
        return;
      }
      if (selectedIndex !== 0) {
        this.enterSchoolYearCode = false;
        this.enterSchoolYearText = '';
      }
      // selectedIndex是下拉框的值 index是孩子下标 inputVal是多年后上学
      this.selectValue = selectedIndex;
      const parames = {
        data: {
          cis: this.cust.cis,
          id: this.editableTabs[index].id,
          currentClass: selectedIndex,
          enterSchoolYear: inputVal,
        },
      };
      this.$_post(this.$API.updateChildrenCurrentClass, parames).then((res) => {
        console.log('sssssss', res);
        if (res.data.msgTip === '1') {
          // 0是不弹加载list接口数据，弹窗点确定请求save接口,取消则还是list接口数据
          this.createdDialog = true;
        }
        // 教育费用概览环形图参数
        const chartData = this.renderChargeOverviewDataFn(
          res.data.childTotalCostInfo.costTotalSmu,
        );
        console.log(chartData, 'chartData');
        this.chargeOverviewData = chartData;
        this.chargeOverviewDataShow = true;
        this.chargeOverviewDataObj = {
          childCount: res.data.childCount,
          lifeCostTotal: res.data.childTotalCostInfo.lifeCostTotal,
          schoolCostTotal: res.data.childTotalCostInfo.schoolCostTotal,
        };
        // 如果没有孩子要完成学业下一步置灰
        if (this.chargeOverviewDataObj.childCount === 0) {
          this.$emit('toNextStepDisabled', true, res.data.childList, 1);
        } else {
          this.$emit('toNextStepDisabled', false, res.data.childList, 1);
        }
        // 存入session给第四步用
        sessionStorage.setItem(
          'childEduChargeOverviewData',
          JSON.stringify(chartData),
        );
        // 以下是教育费用配置
        // 以下是教育费用配置孩子的侧边栏
        this.editableTabs = res.data.childList;
        // 进页面默认展示第一个孩子的数据图
        console.log(res.data.childList[index].custSumList, '***解决');
        if (res.data.childList[index].custSumList !== undefined) {
          this.chargeOverviewData2 = this.renderChargeOverviewData2Fn(
            res.data.childList[index].custSumList,
          );
          this.chargeOverviewData2Show = true;
        }
        // selectValue 控制右边表格显示多少年级
        this.selectValue = res.data.childList[index].currentClass;
        // 以下是获取孩子的右边表格数据 进页面取第一个孩子
        this.children.listFirst = res.data.childList[index].planEduDefultParam;
        this.children.listSecond = res.data.childList[index].childCostInfoList;
        // 下面两个for循环给右边表格数据补 .00
        // eslint-disable-next-line no-restricted-syntax,guard-for-in
        for (const i in this.children.listFirst) {
          if (
            i === 'juniorHighLife'
            || i === 'juniorHighSchool'
            || i === 'kindergartemLife'
            || i === 'kindergartemSchool'
            || i === 'preschoolerLife'
            || i === 'preschoolerSchool'
            || i === 'primaryLife'
            || i === 'primarySchool'
            || i === 'seniorHighLife'
            || i === 'seniorHighSchool'
            || i === 'universityLife'
            || i === 'universitySchool'
          ) {
            // eslint-disable-next-line no-param-reassign
            this.children.listFirst[i] = this.moneyFilter(
              this.children.listFirst[i].toString(),
            );
          }
        }
        this.children.listSecond.forEach((val) => {
          // eslint-disable-next-line guard-for-in,no-restricted-syntax
          for (const i in val) {
            // eslint-disable-next-line no-param-reassign
            val[i] = this.moneyFilter(val[i]);
          }
        });
        // 判断孩子是否都毕业 如果currentClassArr为空数组 则都是上学中
        const currentClassArr = this.editableTabs.filter(
          val => val.currentClass >= 20,
        );
        console.log(currentClassArr, 'kankan');
        if (currentClassArr.length === 0) {
          this.chargeOverviewDataShow = true;
          this.createdChildrenStatus = true;
        } else if (currentClassArr.length === this.editableTabs.length) {
          console.log(this.editableTabs.length);
          // 如果孩子都已经毕业教育费用概览隐藏
          this.chargeOverviewDataShow = false;
          this.$emit('toNextStepDisabled', true, this.editableTabs, 1);
          return;
        }
        console.log('a');
        // eslint-disable-next-line no-restricted-syntax
        for (const i in this.educationReserve) {
          if (
            i === 'currentMoney'
            || i === 'monthMoney'
            || i === 'expectedRevenue'
          ) {
            if (this.educationReserve[i] === '') {
              this.$emit('toNextStepDisabled', true, res.data.childList, 1);
              return;
            }
            this.$emit('toNextStepDisabled', false, res.data.childList, 1);
          }
        }
      });
    },
    updateGetSaveAllChildInfoFn() {
      const a = {
        data: {
          cis: this.cust.cis,
          uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      // 查询费用配置
      this.getSaveAllChildInfoFn(a, 'save');
      this.createdDialog = false;
    },

    // 教育费用配置外层修改方法
    outBlurFn(className, inputVal, e) {
      console.log(inputVal, 'dd');
      if (inputVal === '.') {
        e.target.value = '0.00';
        return;
      }
      // eslint-disable-next-line no-param-reassign
      inputVal = inputVal.replace(/[^\d.]/g, '');
      this.inputFocus = {
        className: '',
        inputVal: '',
        costName: '',
        hierarchy: '',
      };
      // className 是当前哪个输入框的名字, inputVal 是值s
      const parames = {
        data: {
          cis: this.cust.cis,
          id: this.editableTabs[this.editableTabsValue].id,
          columnName: className,
          cost: this.disMoneyFilter(inputVal),
        },
      };
      this.$_post(this.$API.updateOutSchoolCost, parames).then((res) => {
        // 以下是改变右侧数据
        this.editableTabs = res.data.childList;
        console.log(this.editableTabs, '---不会改变的数据');
        // this.ObtainFocus(this.inputFocus.className, this.inputFocus.inputVal, this.inputFocus.costName, this.inputFocus.hierarchy);
        // 以下是改变echarts图
        // 教育费用概览图
        this.chargeOverviewDataObj = {
          childCount: res.data.childCount,
          lifeCostTotal: res.data.childTotalCostInfo.lifeCostTotal,
          schoolCostTotal: res.data.childTotalCostInfo.schoolCostTotal,
        };
        this.chargeOverviewData = this.renderChargeOverviewDataFn(
          res.data.childTotalCostInfo.costTotalSmu,
        );
        this.chargeOverviewDataShow = true;
        // 存入session给第四步用
        sessionStorage.setItem(
          'childEduChargeOverviewData',
          JSON.stringify(this.chargeOverviewData),
        );
        // 教育费用配置图
        this.chargeOverviewData2 = this.renderChargeOverviewData2Fn(
          res.data.childList[this.editableTabsValue].custSumList,
        );
        this.chargeOverviewData2Show = true;

        this.children.listFirst = this.editableTabs[
          Number(this.editableTabsValue)
        ].planEduDefultParam;
        this.children.listSecond = this.editableTabs[
          Number(this.editableTabsValue)
        ].childCostInfoList;
        // 以下是为空补0.00
        e.target.value = this.moneyFilter(e.target.value);
        // eslint-disable-next-line no-restricted-syntax,guard-for-in
        for (const i in this.children.listFirst) {
          if (
            i === 'juniorHighLife'
            || i === 'juniorHighSchool'
            || i === 'kindergartemLife'
            || i === 'kindergartemSchool'
            || i === 'preschoolerLife'
            || i === 'preschoolerSchool'
            || i === 'primaryLife'
            || i === 'primarySchool'
            || i === 'seniorHighLife'
            || i === 'seniorHighSchool'
            || i === 'universityLife'
            || i === 'universitySchool'
          ) {
            // eslint-disable-next-line no-param-reassign
            this.children.listFirst[i] = this.moneyFilter(
              this.children.listFirst[i].toString(),
            );
          }
        }
        this.children.listSecond.forEach((val) => {
          // eslint-disable-next-line guard-for-in,no-restricted-syntax
          for (const i in val) {
            // eslint-disable-next-line no-param-reassign
            val[i] = this.moneyFilter(val[i]);
          }
        });
      });
    },
    renderChargeOverviewDataColorFn(n) {
      let color = '';
      switch (n) {
        case 1:
          color = '#4BA0FF';
          break;
        case 2:
          color = '#35C98C';
          break;
        case 3:
          color = '#FA7575';
          break;
        case 4:
          color = '#FBB849';
          break;
        case 5:
          color = '#D888EA';
          break;
        case 6:
          color = '#F6EC6A';
          break;
        case 7:
          color = '#F592C7';
          break;
        default:
          color = '';
          break;
      }
      return color;
    },
    renderChargeOverviewDataColorOutFn(n) {
      let color = [];
      switch (n) {
        case 1:
          color = ['rgba(75,160,255,0.5)', 'rgba(75,160,255,0.3)'];
          break;
        case 2:
          color = ['rgba(53,201,140,0.5)', 'rgba(53,201,140,0.3)'];
          break;
        case 3:
          color = ['rgba(250,117,117,0.5)', 'rgba(250,117,117,0.3)'];
          break;
        case 4:
          color = ['rgba(251,184,73,0.5)', 'rgba(251,184,73,0.3)'];
          break;
        case 5:
          color = ['rgba(216,136,234,0.5)', 'rgba(216,136,234,0.3)'];
          break;
        case 6:
          color = ['rgba(246,236,106,0.5)', 'rgba(246,236,106,0.3)'];
          break;
        case 7:
          color = ['rgba(245,146,199,0.5)', 'rgba(245,146,199,0.3)'];
          break;
        default:
          color = [];
          break;
      }
      return color;
    },
    // 处理教育费用概览图数据
    renderChargeOverviewDataFn(data) {
      const outArr = [];
      const innerArr = [];
      const titleArr = [];
      let innerObj;
      const colorArr = [];
      const colorArrTwo = [];
      let outLifeCostObj;
      let outSchoolCostObj;
      data.forEach((val) => {
        innerObj = {
          value: val.costTotal,
          name: `${this.schoolLeveFilterFn(val.schoolLevel)}费用`,
        };
        titleArr.push(`${this.schoolLeveFilterFn(val.schoolLevel)}费用`);
        outSchoolCostObj = {
          value: val.schoolCost,
          name: `${this.schoolLeveFilterFn(val.schoolLevel)}学费`,
        };
        outLifeCostObj = {
          value: val.lifeCost,
          name: `${this.schoolLeveFilterFn(val.schoolLevel)}生活费`,
        };
        colorArr.push(this.renderChargeOverviewDataColorFn(val.schoolLevel));
        colorArrTwo.push(
          this.renderChargeOverviewDataColorOutFn(val.schoolLevel)[0],
        );
        colorArrTwo.push(
          this.renderChargeOverviewDataColorOutFn(val.schoolLevel)[1],
        );
        innerArr.push(innerObj);
        outArr.push(outLifeCostObj);
        outArr.push(outSchoolCostObj);
      });
      return {
        title: {
          text: '',
          subtext: '',
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : ({d}%)',
        },
        legend: {
          selectedMode: false,
          orient: 'horizontal',
          x: 'center',
          y: 'bottom',
          data: titleArr,
        },
        backgroundColor: '#ffffff',
        series: [
          // 内圈
          {
            name: '事业线',
            type: 'pie',
            center: ['50%', '40%'],
            radius: ['30%', '50%'],
            color: colorArr,
            label: {
              normal: {
                show: false,
              },
            },
            data: innerArr,
          },
          // 外圈
          {
            name: '分组',
            type: 'pie',
            center: ['50%', '40%'],
            radius: ['50%', '65%'],
            color: colorArrTwo,
            labelLine: {
              normal: {
                show: false,
              },
            },
            label: {
              show: false,
            },
            data: outArr,
          },
        ],
      };
    },
    // 处理教育费用配置图数据
    renderChargeOverviewData2Fn(data) {
      const outArr2 = [];
      const innerArr2 = [];
      const titleArr2 = [];
      let innerObj2;
      const colorArr2 = [];
      const colorArrTwo2 = [];
      let outSchoolCostObj2;
      let outLifeCostObj2;
      console.log(data, 'data数据');
      data.forEach((val) => {
        innerObj2 = {
          value: val.costTotal,
          name: `${this.schoolLeveFilterFn(val.schoolLevel)}费用`,
        };
        titleArr2.push(`${this.schoolLeveFilterFn(val.schoolLevel)}费用`);
        outSchoolCostObj2 = {
          value: val.schoolCost,
          name: `${this.schoolLeveFilterFn(val.schoolLevel)}学费`,
        };
        outLifeCostObj2 = {
          value: val.lifeCost,
          name: `${this.schoolLeveFilterFn(val.schoolLevel)}生活费`,
        };
        colorArr2.push(this.renderChargeOverviewDataColorFn(val.schoolLevel));
        colorArrTwo2.push(
          this.renderChargeOverviewDataColorOutFn(val.schoolLevel)[0],
        );
        colorArrTwo2.push(
          this.renderChargeOverviewDataColorOutFn(val.schoolLevel)[1],
        );
        innerArr2.push(innerObj2);
        outArr2.push(outLifeCostObj2);
        outArr2.push(outSchoolCostObj2);
      });
      return {
        title: {
          text: '',
          subtext: '',
          x: 'center',
          y: 'center',
          subtextStyle: {
            color: '#333',
            fontSize: 20,
          },
        },
        legend: {
          selectedMode: false,
          orient: 'horizontal',
          x: 'left',
          y: 'bottom',
          data: titleArr2,
        },
        backgroundColor: '#ffffff',
        series: [
          // 内圈
          {
            name: '事业线',
            type: 'pie',
            radius: ['15%', '20%'],
            color: colorArr2,
            label: {
              normal: {
                show: false,
              },
            },
            data: innerArr2,
          },
          // 外圈
          {
            name: '分组',
            type: 'pie',
            radius: ['20%', '30%'],
            color: colorArrTwo2,
            labelLine: {
              normal: {
                length: 25,
                length2: 20,
                smooth: 0,
              },
            },
            label: {
              normal: {
                formatter: '{h|{b}}{brd|{d}%}',
                backgroundColor: '#fff',
                borderColor: '#aaa',
                borderWidth: 1,
                borderRadius: 4,
                padding: [0, 10],
                rich: {
                  h: {
                    lineHeight: 30,
                    padding: [10, 5],
                    verticalAlign: 'top',
                  },
                  abg: {
                    backgroundColor: '#333',
                    width: '100%',
                    align: 'right',
                    height: 10,
                    borderRadius: [4, 4, 0, 0],
                  },
                  brd: {
                    color: '#eee',
                    backgroundColor: '#606266',
                    padding: [3, 6],
                    borderRadius: 2,
                    lineHeight: '7',
                  },
                },
              },
            },
            data: outArr2,
          },
        ],
      };
    },
    // 教育费用配置内层修改方法
    innerBlurFn(className, inputVal, inputType, e) {
      console.log(inputVal);
      console.log(inputType, 'inputType');
      if (inputVal === '.') {
        e.target.value = '0.00';
        return;
      }
      // 避免输入汉字的情况
      // eslint-disable-next-line no-param-reassign
      inputVal = inputVal.replace(/[^\d.]/g, '');
      this.inputFocus = {
        className: '',
        inputVal: '',
        costName: '',
        hierarchy: '',
      };
      // className 是当前哪个输入框的名字, inputVal 是值
      const parames = {
        data: {
          cis: this.cust.cis,
          id: this.editableTabs[this.editableTabsValue].id,
          columnName: className,
          cost: this.disMoneyFilter(inputVal),
          costType: inputType,
        },
      };
      this.$_post(this.$API.updateInnerSchoolCost, parames).then((res) => {
        console.log(res, 'dddddddddddddddddddd');
        this.editableTabs = res.data.childList;
        console.log(this.editableTabs, '---不会改变的数据');
        // 以下是改变echarts图
        // 教育费用概览图
        this.chargeOverviewDataObj = {
          childCount: res.data.childCount,
          lifeCostTotal: res.data.childTotalCostInfo.lifeCostTotal,
          schoolCostTotal: res.data.childTotalCostInfo.schoolCostTotal,
        };
        this.chargeOverviewData = this.renderChargeOverviewDataFn(
          res.data.childTotalCostInfo.costTotalSmu,
        );
        this.chargeOverviewDataShow = true;
        // 存入session给第四步用
        sessionStorage.setItem(
          'childEduChargeOverviewData',
          JSON.stringify(this.chargeOverviewData),
        );
        // 教育费用配置图
        this.chargeOverviewData2 = this.renderChargeOverviewData2Fn(
          res.data.childList[this.editableTabsValue].custSumList,
        );
        this.chargeOverviewData2Show = true;
        // 以下是补0.00
        e.target.value = this.moneyFilter(e.target.value);
        // eslint-disable-next-line no-restricted-syntax,guard-for-in
        for (const i in this.children.listFirst) {
          console.log('i', i);
          if (
            i === 'juniorHighLife'
            || i === 'juniorHighSchool'
            || i === 'kindergartemLife'
            || i === 'kindergartemSchool'
            || i === 'preschoolerLife'
            || i === 'preschoolerSchool'
            || i === 'primaryLife'
            || i === 'primarySchool'
            || i === 'seniorHighLife'
            || i === 'seniorHighSchool'
            || i === 'universityLife'
            || i === 'universitySchool'
          ) {
            // eslint-disable-next-line no-param-reassign
            this.children.listFirst[i] = this.moneyFilter(
              this.children.listFirst[i].toString(),
            );
            console.log(this.children.listFirst[i]);
          }
        }
        this.children.listSecond.forEach((val) => {
          // eslint-disable-next-line guard-for-in,no-restricted-syntax
          for (const i in val) {
            console.log('val', val[i]);
            // eslint-disable-next-line no-param-reassign
            val[i] = this.moneyFilter(val[i]);
          }
        });
      });
    },
    // 查省份
    getDialogSelectFn(parames) {
      this.$_post(this.$API.getListAllProvinceName, parames).then((res) => {
        console.log(res.data.list, '------');
        this.msgProvinceSelectOptions = [
          {
            provinceName: '全部',
            provinceId: '0',
          },
        ];
        this.msgProvinceSelectOptions = this.msgProvinceSelectOptions.concat(
          res.data.list,
        );
      });
    },
    // 查城市
    dialogChangeFn(val) {
      // val 是当前选择省份
      const parames = {
        data: {
          parentId: val === '0' ? '000000' : val,
          countryType: '1',
        },
      };
      this.$_post(this.$API.getListAllProvinceName, parames).then((res) => {
        this.msgCitySelectOptions = [
          {
            provinceName: '全部',
            provinceId: '0',
          },
        ];
        this.msgCitySelectOptions = this.msgCitySelectOptions.concat(
          res.data.list,
        );
        this.msgCitySelectValue = '0';
        // 省份选择全部 城市默认为全部
        if (val === '0' || val === 0) {
          this.msgCitySelectOptions = [
            {
              provinceName: '全部',
              provinceId: '0',
            },
          ];
        }
      });
    },
    getDialogQueryFn(province, city, currentPage, type) {
      // type等于1是查询, 2是分页 province省份, city城市 currentPage当前页
      if (type === 1) {
        // eslint-disable-next-line no-param-reassign
        currentPage = 1;
      }
      const parames = {
        pageMessage: {
          pageSize: this.pageSize,
          pageNo: currentPage,
        },
        data: {
          parentId: province === '0' ? '' : province,
          provinceId: city === '0' ? '' : city,
          countryType: '1',
        },
      };
      this.$_post(this.$API.getListProvinceCostInfo, parames).then((res) => {
        // 点击查询确定当前查询条件 暂时存下来给分页用
        this.msgProvinceSelectValueAffirmative = province;
        this.msgCitySelectValueAffirmative = city;
        this.tableData = res.data.list;
        this.sumCount = res.sumCount;
      });
    },
    // 国外收费
    getDialogQueryOutFn() {
      const parames = {
        data: {
          parentId: '010',
          countryType: '2',
        },
      };
      this.$_post(this.$API.getListAllAbroadCostInfo, parames).then((res) => {
        this.tableDataOut = res.data.list;
      });
    },
    // 预计多少年后入学的input
    selectBlur(a, b, data, e) {
      if (!e.target.value) {
        this.$emit('toNextStepDisabled', true, this.editableTabs, 1);
        this.enterSchoolYearCode = true;
        this.enterSchoolYearText = '请输入预计入学时间';
        return;
      }
      this.enterSchoolYearCode = false;
      this.enterSchoolYearText = '';
      if (!/^[0-9]{1}$/.test(data)) {
        e.target.value = data.toString().slice(0, 1);
      } else {
        e.target.value = data;
      }
      this.$emit('toNextStepDisabled', false, this.editableTabs, 1);
      this.selectChange(a, b, e.target.value);
      // eslint-disable-next-line no-restricted-syntax
      for (const i in this.educationReserve) {
        if (
          i === 'currentMoney'
          || i === 'monthMoney'
          || i === 'expectedRevenue'
        ) {
          if (this.educationReserve[i] === '') {
            this.$emit('toNextStepDisabled', true, this.editableTabs, 1);
            return;
          }
          this.$emit('toNextStepDisabled', false, this.editableTabs, 1);
        }
      }
    },
  },
};
</script>
<style lang="scss">
.dataCollection {
  /*input校验*/
  .verificationText {
    color: #f56c6c !important;
    font-size: 12px;
    line-height: 1;
  }
  .verificationText-style-enter-active {
    transition: all 0.2s ease;
  }
  .verificationText-style-leave-active {
    transition: all 0.2s ease;
  }
  .verificationText-style-enter,
  .verificationText-style-leave-to {
    transform: translateY(-15px);
  }
  .el-input__inner {
    padding: 0 3px;
  }
  .el-tabs__header {
    min-width: 110px;
  }
  .el-tabs__item {
    box-shadow: 0 0 2px 2px transparent inset !important;
  }
  .el-tabs__item {
    color: #606266;
  }
  .el-tabs__item.is-active {
    color: #303133;
    font-weight: bold;
    background-color: rgba(30, 136, 255, 0.15);
  }
  /*收费标准弹窗*/
  .el-dialog__body {
    padding: 10px 20px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .msgTitle {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
  }
  .msg-main-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    padding-left: 3%;
    margin: 3% 0 2%;
    p {
      margin-right: 5px;
    }
    .el-select {
      margin-right: 4%;
    }
  }
  .el-pagination {
    text-align: center;
    .el-input {
      width: 50px !important;
    }
  }
  .yh-dialog .el-input {
    width: 200px;
  }
  /*input样式*/
  .keep_input {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  .keep_input:focus {
    border-color: #54a6de;
    outline: 0;
  }
  .addChildStyle {
    display: inline;
    position: relative;
    left: 0;
    top: 10px;
    padding: 0 20px;
    cursor: pointer;
  }

  /*教育费用概览*/
  .chargeOverview {
    background: rgba(255, 255, 255, 1);
    .chargeOverview-top {
      padding: 15px 20px;
      border-bottom: 1px solid #eeeeee;
      h3 {
        font-size: 16px;
        font-weight: 400;
        color: rgba(48, 49, 51, 1);
        line-height: 24px;
      }
    }
    .chargeOverview-bottom {
      height: 300px;
      padding: 0 20px;
      display: flex;
      justify-content: flex-start;
      flex-wrap: nowrap;
      .chargeOverview-bottom-left {
        width: 50%;
        padding: 5px 0;
        border-right: 1px solid #eeeeee;
        display: flex;
        justify-content: flex-start;
        flex-wrap: nowrap;
        align-items: center;
        .echarts {
          width: 300px;
          height: 210px;
        }
        p {
          width: 250px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(96, 98, 102, 1);
          line-height: 21px;
          span {
            color: #f95353;
          }
        }
      }
      .chargeOverview-bottom-right {
        width: 50%;
        padding: 16px 30px;
        .chargeOverview-bottom-right-title {
          display: flex;
          justify-content: flex-start;
          flex-wrap: nowrap;
          align-items: center;
          h4 {
            font-size: 14px;
            font-weight: 500;
            color: rgba(48, 49, 51, 1);
            line-height: 21px;
            margin-right: 6px;
          }
          img {
            width: 14px;
            height: 15px;
          }
        }
        .chargeOverview-bottom-right-main {
          > div {
            margin-bottom: 10px;
            display: flex;
            justify-content: flex-start;
            flex-wrap: nowrap;
            align-items: center;
            p {
              font-size: 14px;
              font-weight: 400;
              color: rgba(96, 98, 102, 1);
              line-height: 21px;
            }
            .el-input {
              width: 156px;
              margin: 0 10px;
            }
          }
        }
      }
    }
  }
  /*教育费用配置*/
  .chargeSetting {
    margin: 12px 0 20px;
    background: rgba(255, 255, 255, 1);
    .chargeSetting-top {
      padding: 15px 20px;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content: flex-start;
      flex-wrap: nowrap;
      align-items: center;
      h4 {
        font-size: 14px;
        font-weight: 500;
        color: rgba(48, 49, 51, 1);
        line-height: 21px;
        margin-right: 6px;
      }
      img {
        width: 14px;
        height: 15px;
      }
    }
    .chargeSetting-bottom {
      padding: 0 20px 20px 0;
      display: flex;
      justify-content: flex-start;
      flex-wrap: nowrap;
      .el-tabs--left .el-tabs__header.is-left {
        margin-top: 12px;
      }
      .chargeSetting-bottom-left {
        position: relative;
        height: 430px;
        width: 60%;
        .el-select {
          width: 130px;
          margin: 0 10px;
        }
        .echarts {
          width: 550px;
          height: 320px;
        }
        .el-tabs--left .el-tabs__active-bar.is-left {
          left: 0;
          right: auto;
        }
        .el-tabs__nav {
          margin-top: 12px;
        }
        .el-tabs--left .el-tabs__header.is-left {
          margin-top: 0;
        }
        .el-tabs--left .el-tabs__nav-wrap.is-left::after {
          background-color: #eeeeee;
          height: 100%;
          width: 2px;
        }
      }
      .chargeSetting-bottom-right {
        width: 40%;
        .chargeSetting-bottom-right-title {
          background: rgba(245, 247, 250, 1);
          padding: 11px 28px 11px 36px;
          ul {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: nowrap;
            li {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              flex-wrap: nowrap;
              &:nth-child(1),
              &:nth-child(2) {
                width: 22%;
                justify-content: flex-start;
              }
              &:nth-child(3) {
                width: 20%;
                margin-left: 10%;
                justify-content: flex-end;
              }
              &:nth-child(4) {
                width: 24%;
                justify-content: flex-end;
              }
              p {
                margin-right: 3px;
              }
            }
          }
        }
        .chargeSetting-bottom-right-msg {
          margin-top: 15px;
          padding-left: 20px;
          p {
            font-size: 14px;
            font-weight: 400;
            color: rgba(96, 98, 102, 1);
            line-height: 21px;
            span {
              color: #1e88ff;
              cursor: pointer;
            }
          }
        }
        .el-row {
          width: 100%;
          .el-col:first-of-type {
            text-align: center;
          }
          .el-col:nth-child(2) {
            .el-input {
              margin-right: 10px;
            }
          }
        }
        .flex-div {
          padding: 8px 0 8px 36px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: nowrap;
          width: 100%;
          > .checkbox-div {
            display: flex;
            width: 40%;
            .el-input {
              width: 70%;
              padding-left: 11px;
            }
          }
          > div:last-of-type {
            width: 60%;
            text-align: right;
            box-sizing: border-box;
          }
          > span {
            box-sizing: border-box;
          }
          .el-input {
            margin-right: 4%;
            box-sizing: border-box;
          }
        }
        .flex-div-inner {
          padding: 8px 28px 8px 36px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: nowrap;
          > div:nth-child(2) {
            width: 62%;
            text-align: right;
            box-sizing: border-box;
          }
          .flex-div-inner-left {
            margin-left: 20%;
          }
          .el-input:first-of-type {
            margin-right: 4%;
          }
        }
        .el-collapse-item__header {
          line-height: 36px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: nowrap;
        }
        .el-collapse-item__arrow {
          margin: 0 8px 0 0;
        }
        .el-input {
          width: 37%;
          height: 36px;
          .el-input__inner {
            height: 36px;
            line-height: 36px;
          }
        }
      }
    }
  }
  .analysisTabs-second-false {
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    padding: 90px 0 130px;
    div {
      font-size: 14px;
      font-weight: 400;
      color: rgba(96, 98, 102, 1);
      line-height: 21px;
      margin-left: 60px;
      p {
        margin-bottom: 20px;
      }
      .el-button {
        padding: 12px 25px;
      }
    }
  }
}
</style>
